import moment from 'moment-timezone'
import {sha256} from "js-sha256";
import constants from '../constants.js'
import lodash from 'lodash'
import main from '../main'
const { Buffer } = require('buffer');
import { setupExperiments } from '@pizza-hut/lib-experiments/lib'

const UNIQUE_KEY_PROP = '__unique_key_prop__'
const KEY_PREFIX = '__key_prefix__' + Date.now() + '_'
let uid = 0
const isObject = val => val !== null && typeof val === 'object'
const genUniqueKey = obj => {
  if (isObject(obj)) {
    if (UNIQUE_KEY_PROP in obj) {
      return obj[UNIQUE_KEY_PROP]
    }
    const value = KEY_PREFIX + uid++
    Object.defineProperty(obj, UNIQUE_KEY_PROP, {value})
    return value
  }
  return obj
}

import ASAPPopup from '../components/popup/OrderASAP'

export default {
  data: function () {
    return {
      cart: {},
      disposition: {}
    }
  },
  methods: {
    genUniqueKey,
    isMobile: function () {
      return window.innerWidth <= 768
    },
    isMobileApp: function() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
    checkIOSAndSafari: function () {
      const userAgent = window.navigator.userAgent
      const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && userAgent && userAgent.indexOf('CriOS') == -1 && userAgent.indexOf('FxiOS') == -1;
      return /iP(ad|od|hone)|Mac OS/i.test(userAgent) && isSafari
    },
    /**
     * This function is same as PHP's nl2br() with default parameters.
     *
     * @param {string} str Input text
     * @param {boolean} replaceMode Use replace instead of insert
     * @param {boolean} isXhtml Use XHTML
     * @return {string} Filtered text
     */
    nl2brMethod (str, replaceMode, isXhtml) {
      let breakTag = (isXhtml) ? '<br />' : '<br>'
      let replaceStr = (replaceMode) ? '$1' + breakTag : '$1' + breakTag + '$2'
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr)
    },
    /**
     * Get full url
     * */
    url: function (link) {
      return process.env.BASE_URL + '/' + link
    },
    /**
     * Redirect page
     * */
    redirect: function (url) {
      window.location.href = url
    },
    /**
     * Get current path
     * */
    getCurrentPath() {
      return window.location.pathname
    },
    /**
     * Checking has disposition
     * */
    checkPosition: function (vm) {
      return vm.$session.has('disposition') && vm.$session.get('disposition').outletId !== undefined
    },
    /**
     * Checking has disposition
     * */
    getOutletCode: function (vm) {
      return vm.checkPosition(vm) ? vm.$session.get('disposition').outletCode : ''
    },
    /**
     * Check empty variable
     * */
    empty: function (param) {
      if (param == null) {
        return true
      }
      if (typeof param === 'object') {
        return Object.keys(param).length <= 0
      }

      if (typeof param === 'string') {
        return param.length <= 0
      }

      if (param instanceof Array) {
        return param.length <= 0
      }
      return false
    },
    removeDispositionAndCart(vm) {
      vm.$session.remove('cart')
      vm.$session.remove('disposition')
      vm.$session.remove('vouchers')
    },
    /**
     * Get delivery info
     * */
    getDeliveryInfo(vm) {
      let disposition = vm.$session.has('disposition') ? vm.$session.get('disposition') : ''
      if (typeof disposition.outletId === 'undefined') return {orderType: '', addressInfo: ''}
      let strAddress = disposition.outletName
      if (disposition.orderType === vm.$const.DELIVERY) {
        let _address = []
        _address.push(disposition.villeageName)
        if (disposition.cityName) {
          _address.push(disposition.cityName)
        }
        if (disposition.prefectureName) {
          _address.push(disposition.prefectureName)
        }
        strAddress = _address.join(', ')
      }
      if (typeof strAddress === 'undefined' || !strAddress) {
        return {orderType: '', addressInfo: ''}
      }
      let addressInfo = strAddress
      let orderType = disposition.orderType == vm.$const.DELIVERY ? vm.$const.DELIVERY.toLowerCase() : vm.$const.CARRYOUT.toLowerCase()
      let info = {orderType, addressInfo}
      return info
    },
    convertDateTimeToUTC(datetime) {
      if (!datetime) {
        return moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }

      let chkdate = moment(datetime)
      if (!chkdate.isValid()) {
        return moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }
      return chkdate.utc().format('YYYY-MM-DD HH:mm:ss')
    },
    convertUTCToClientTime(datetime) {
      if (!datetime) {
        return ''
      }
      return moment.utc(datetime).local()
    },
    convertUTCToTimeZone(datetime, timezone) {
      if (!datetime) {
        return moment.utc(new Date()).tz(timezone)
      }
      return moment.utc(datetime).tz(timezone)
    },
    convertDateTimeFromTimezoneToUTC(timezone, datetime) {
      if (!timezone) {
        return this.convertDateTimeToUTC(datetime)
      }
      if (!datetime) {
        return moment.tz(timezone).utc().format('YYYY-MM-DD HH:mm:ss')
      }

      let chkdate = moment.tz(datetime, timezone)
      if (!chkdate.isValid()) {
        return moment.tz(timezone).utc().format('YYYY-MM-DD HH:mm:ss')
      }
      return chkdate.utc().format('YYYY-MM-DD HH:mm:ss')
    },
    convertToUTCIfHasTimezone(vm, datetime) {
      let disposition = vm.$session.get('disposition')
      let timezone = false
      if (typeof disposition !== 'undefined' && typeof disposition['collectionTime'] !== 'undefined') {
        timezone = disposition['timezone']
      }
      if (!timezone) {
        return this.convertDateTimeToUTC(datetime)
      }
      return this.convertDateTimeFromTimezoneToUTC(timezone, datetime)
    },
    getCurrentDateLocal() {
      return moment(new Date()).format('YYYY-MM-DD')
    },
    /**
     * Get collection time (client timezone)
     * Show on header main and checkout page
     * */
    getTimePicker(vm, isHtml = false) {
      let disposition = vm.$session.get('disposition')
      let collectionTime = false
      let timezone = false
      if (typeof disposition !== 'undefined' && typeof disposition['collectionTime'] !== 'undefined') {
        collectionTime = disposition['collectionTime']
        timezone = disposition['timezone']
      }

      let today = !timezone ? moment(new Date()).format('DD-MM-YYYY') : moment.tz(timezone).format('DD-MM-YYYY')
      let nextday = !timezone ? moment(new Date()).add(1, 'days').format('DD-MM-YYYY') : moment.tz(timezone).add(1, 'days').format('DD-MM-YYYY')
      let pickedDay = collectionTime ? this.convertDay(collectionTime.pickedDay) : ''
      let pickedHours = collectionTime ? this.convertHour(collectionTime.pickedHours)  : ''
      let result = ''

      let isAsap = false
      if (!vm.$session.has('disposition') || (disposition['advanceOrder'] === 'undefined' || disposition['advanceOrder'] == 0 || disposition['advanceOrder'] == '')) {
        result = vm.$t('asap') || ''
        isAsap = true
      } else if (pickedDay == today) {
        result = vm.$t('today') || ''
      } else if (pickedDay == nextday) {
        result = vm.$t('tomorrow') || ''
      } else {
        result = this.convertDay(collectionTime.pickedDay)
      }

      if (isHtml) {
        result = '<span>' + result + '</span>'
      }

      if (!isAsap) {
        if (isHtml) {
          result += '<span>' + pickedHours + '</span>'
        } else {
          result += ' ' + pickedHours
        }
      }

      return result
    },
    /**
     *
     * Get collection time (client timezone)
     * To pass ordertime to api (cart api)
     * return YYYY-MM-DD HH:mm:ss
     * */
    getTimePickerDate(vm) {
      let disposition = vm.$session.get('disposition')
      let today = moment(new Date()).format('YYYY-MM-DD')
      let collectionTime = today + ' ' + moment(new Date()).format('HH:mm')
      if (typeof disposition !== 'undefined' && typeof disposition['collectionTime'] !== 'undefined') {
        collectionTime = disposition['collectionTimeValue'] + ':00'
        let timezone = disposition['timezone']
        if (disposition['advanceOrder'] === 'undefined' || disposition['advanceOrder'] == 0 || disposition['advanceOrder'] == '') {
          return moment.tz(timezone).local().format('YYYY-MM-DD HH:mm:ss')
        }
        let datatime = moment.tz(collectionTime, timezone)
        if (datatime.isValid) {
          return datatime.local().format('YYYY-MM-DD HH:mm:ss')
        }
      }
      if (!vm.$session.has('disposition')) {
        collectionTime = today + ' ' + moment(new Date()).format('HH:mm:ss')
      }
      return collectionTime
    },
    convertHour(hour) {
      if(hour === this.$t('asap')) {
        return hour
      }
      return moment(hour, ['HH:mm']).format('hh:mm A')
    },
    convertDay(day){
      return moment(day).format('DD-MM-YYYY')
    },
    getTimePickerDateNoneConvert(vm) {
      let disposition = vm.$session.get('disposition')
      let collectionTime = moment(new Date())
      if (typeof disposition !== 'undefined' && typeof disposition['collectionTime'] !== 'undefined') {
        collectionTime = disposition['collectionTimeValue'] + ':00'
        let timezone = disposition['timezone']
        if (disposition['advanceOrder'] === 'undefined' || disposition['advanceOrder'] == 0 || disposition['advanceOrder'] == '') {
          return moment.tz(timezone)
        }
        let datatime = moment.tz(collectionTime, timezone)
        if (datatime.isValid) {
          return datatime
        }
      }
      if (!this.$session.has('disposition')) {
        collectionTime = moment(new Date())
      }
      return collectionTime
    },
    /**
     * Get payment name
     * */
    getPaymentName(val) {
      let name = ''
      switch (val) {
        case 7:
          name = 'Creadit Card'
          break
        case 5:
          name = 'Maybank2U'
          break
        case 9:
          name = 'Cash'
          break
        case 4:
          name = 'Master Card'
          break
      }
      return name
    },
    /**
     * Convert string
     * */
    convertString(str) {
      if (typeof str === undefined || typeof str === 'undefined' || str.length <= 0) {
        return ''
      }
      let arrstr = str.split(' ')
      let result = ''
      for (var val in arrstr) {
        var lowstr = arrstr[val].toLowerCase()
        var upstr = lowstr.charAt(0).toUpperCase() + lowstr.slice(1)
        result += upstr + ' '
      }
      return result.trim()
    },
    /**
     * Convert string to snake-case
     *
     * Ex:
     *    INPUT: 'sample String  test    foo   bar  '
     *    OUTPUT: 'sample-string-test-foo-bar'
     * */
    convertStringSnakeCase(str) {
      if (typeof str === undefined || typeof str === 'undefined' || str.length <= 0) {
        return ''
      }

      // START <space> sanitizer
      const regxReduceSpace = /\s{2,}/gi
      while (regxReduceSpace.test(str)) {
        str = str.replace(regxReduceSpace, ' ')
      }
      str = str.trim()
      // END ./ <space> sanitizer

      let arrstr = str.split(' ')
      let result = ''

      arrstr.forEach((val, i) => {
        var lowstr = arrstr[i].toLowerCase()

        // add '-' character, except for LAST WORD of string
        if (i < arrstr.length - 1) {
          result += lowstr + '-'
        } else {
          result += lowstr
        }
      })

      return result.trim()
    },
    /**
     * Format number
     * */
    formatNum(num) {
      num = num || 0
      return parseFloat(Math.round(num * 100) / 100).toFixed(constants.CURRENCY_FORMAT)
    },
    /**
     * Format number
     * */
    formatNumDisplay(num) {
      num = num || 0
      return parseFloat(Math.round(num * 100) / 100).toFixed(constants.CURRENCY_FORMAT).replace(constants.CURRENCY_RGX, constants.CURRENCY_DEC_POINT)
    },
    formatNum2Fix(num) {
      num = num || 0
      return parseFloat(Math.round(num * 100) / 100).toFixed(2)
    },
    checkNum(num) {
      return parseFloat(num || 0)
    },
    // sumNum (num1, num2) {
    //   num1 = parseFloat(num1 || 0)
    //   num2 = parseFloat(num2 || 0)
    //   let num = num1 + num2
    //   return (Math.round(num * 100) / 100).toFixed(2)
    // },
    sumNum(num1, num2, num3) {
      num1 = parseFloat(num1 || 0)
      num2 = parseFloat(num2 || 0)
      num3 = parseFloat(num3 || 0)
      let num = num1 + num2 + num3
      return (Math.round(num * 100) / 100).toFixed(constants.CURRENCY_FORMAT)
    },
    sumNumWithoutFormat(num1, num2) {
      num1 = parseFloat(num1 || 0)
      num2 = parseFloat(num2 || 0)
      let num = num1 + num2
      return Math.round(num * 100) / 100
    },
    clearNotification(vm, group) {
      group = group || ''
      vm.$notify({
        group: group,
        clean: true
      })
    },
    isOneSideOneCrust(item) {
      // return TRUE IF first_layers.length == 1 && second_layers.length == 1
      if (item
        && item.first_layers && item.first_layers.length == 1
        && item.first_layers[0].second_layers && item.first_layers[0].second_layers.length <= 1
      ) {
        return true
      } else {
        return false
      }
    },
    /**
     * Format number
     * */
    formatPercent(num) {
      return parseFloat(Math.round(num * 100) / 100).toFixed(0)
    },
    /**
     * Checking valid email field
     * @param email
     * @returns {boolean}
     */
    validEmail(email) {
      // let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      let re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,16})+$/
      return re.test(email)
    },
    getUserDatalayer(vm) {
      let userinfo = vm.$auth.check() ? vm.$auth.user() : {}
      let address = userinfo.locations != null && userinfo.locations.length ? userinfo.locations[0].house_no + ' ' + userinfo.locations[0].location : ''
      let user = {
        'status': !this.empty(userinfo) ? 'logged-in' : 'logged-out',
        'customer': {
          'id': !this.empty(userinfo) && !this.empty(userinfo.email) ? sha256(userinfo.email) : '',
          'status': !this.empty(userinfo) && ((userinfo.outlets != null && userinfo.outlets.length > 0) || (userinfo.locations != null && userinfo.locations.length)) ? 'repeat' : 'new',
          'phone': !this.empty(userinfo) && !this.empty(userinfo.phone) ? sha256(userinfo.phone) : '',
          'postal_code': !this.empty(userinfo) ? (!this.empty(userinfo.postal_code) ? sha256(userinfo.postal_code) : (userinfo.locations != null && userinfo.locations.length ? sha256(address) : '')) : ''
        },
        'PH_User_Device': 'website',
        'external_id': !this.empty(userinfo) ? sha256(userinfo.email) : '',
        'device': {
          'typeRollup': this.isMobile() ? 'mobile' : 'desktop'
        }
      }
      return user
    },
    getFlatformDatalayer(vm) {
      let flatform = vm.$const.DATA_LAYER.PLATFORM
      flatform.environment = process.env.NODE_ENV
      flatform.localeLanguage = vm.$i18n.locale
      return flatform
    },
    /**
     * Branch.io
     * Custom Event
     */
    addCustomEvent(type, orderType) {
      try {
        console.info("+++++++++++++++addCustomEvent start+++++++++++++++++")
        let custom_data = {
          "type": orderType
        }
        type = type === constants.CARRYOUT ? 'takeaway' : type

        branch.logEvent(
          type.toUpperCase(),
          custom_data,
          function (_err) {
            if(_err) {
              console.info('+++++++++++++addCustomEvent error ++++++++++++++')
              console.info(_err)
            }
          }
        );
        console.info("+++++++++++++++addCustomEvent end+++++++++++++++++")
      } catch (error) {
        console.info("+++++++++++++addCustomEvent call API error")
        console.log(error)
      }
    },

    /**
     * test
     */
    addCommerceEvent (type, item) {
      console.info('+++++++++++++HARSH TEST start ++++++++++++++')
      var event_and_custom_data = {
         "transaction_id": "tras_Id_1232343434",
         "currency": "USD",
         "revenue": 180.2,
         "shipping": 10.5,
         "tax": 13.5,
         "coupon": "promo-1234",
         "affiliation": "high_fi",
         "description": "Preferred purchase",
         "purchase_loc": "Palo Alto",
         "store_pickup": "unavailable"
      };

      var content_items = [
      {
         "$content_schema": "COMMERCE_PRODUCT",
         "$og_title": "Nike Shoe",
         "$og_description": "Start loving your steps",
         "$og_image_url": "http://example.com/img1.jpg",
         "$canonical_identifier": "nike/1234",
         "$publicly_indexable": false,
         "$price": 101.2,
         "$locally_indexable": true,
         "$quantity": 1,
         "$sku": "1101123445",
         "$product_name": "Runner",
         "$product_brand": "Nike",
         "$product_category": "Sporting Goods",
         "$product_variant": "XL",
         "$rating_average": 4.2,
         "$rating_count": 5,
         "$rating_max": 2.2,
         "$creation_timestamp": 1499892854966,
         "$exp_date": 1499892854966,
         "$keywords": [ "sneakers", "shoes" ],
         "$address_street": "230 South LaSalle Street",
         "$address_city": "Chicago",
         "$address_region": "IL",
         "$address_country": "US",
         "$address_postal_code": "60604",
         "$latitude": 12.07,
         "$longitude": -97.5,
         "$image_captions": [ "my_img_caption1", "my_img_caption_2" ],
         "$condition": "NEW",
         "$custom_fields": {"foo1":"bar1","foo2":"bar2"}
      },
      {
         "$og_title": "Nike Woolen Sox",
         "$canonical_identifier": "nike/5324",
         "$og_description": "Fine combed woolen sox for those who love your foot",
         "$publicly_indexable": false,
         "$price": 80.2,
         "$locally_indexable": true,
         "$quantity": 5,
         "$sku": "110112467",
         "$product_name": "Woolen Sox",
         "$product_brand": "Nike",
         "$product_category": "Apparel & Accessories",
         "$product_variant": "Xl",
         "$rating_average": 3.3,
         "$rating_count": 5,
         "$rating_max": 2.8,
         "$creation_timestamp": 1499892854966
      }];

      var customer_event_alias = "my custom alias";

      branch.logEvent(
         "PURCHASE",
         event_and_custom_data,
         content_items,
         customer_event_alias,
         function(err) { console.log(err); }
      );
     console.log('event_and_custom_data',event_and_custom_data)
     console.log('content_items',content_items)
     console.log('customer_event_alias',customer_event_alias)
     console.info('+++++++++++++HARSH TEST end ++++++++++++++')
     },

    /**
     * Branch.io CommerceEvent
     */
    // addCommerceEvent (type, item) {
    //   try {
    //     console.info('+++++++++++++addCommerceEvent start ++++++++++++++')
    //     console.info('+++++++++++++addCommerceEvent type ++++++++++++++')
    //     console.info(type)
    //     const cart = this.$cart.get(this)
    //     const event_and_custom_data = {
    //       'transaction_id': cart.uuid ? cart.uuid : '',
    //       'revenue': cart.total ? cart.total : 0,
    //       'shipping': cart.delivery_fee ? cart.delivery_fee : 0,
    //       'tax': cart.tax_total ? cart.tax_total : 0,
    //       'coupon': cart.current_coupon_item && cart.current_coupon_item.coupon ? cart.current_coupon_item.coupon : '',
    //       'affiliation': this.$disposition.getByKey(this, 'outletName', ''),
    //       'description': type
    //     }
    //     const content_items = []
    //     let data = cart.data
    //     if (type === 'ADD_TO_CART') {
    //       data = [item.item]
    //       console.log('data', data)
    //       // item.item.item_price = cart.total ? cart.total : 0
    //     }
    //     data.forEach(item => {
    //       const obj = {
    //         '$og_title': item.name ? item.name : '',
    //         '$og_description': '',
    //         '$og_image_url': '',
    //         '$canonical_identifier': window.location.pathname,
    //         '$publicly_indexable': false,
    //         '$price': item.item_price ? item.item_price : 0,
    //         '$quantity': item.quantity ? item.quantity : 1,
    //         '$sku': item.items && item.items.length > 0 ? item.items[0].product_sku : '',
    //         '$product_name': item.name ? item.name : '',
    //         '$product_brand': '',
    //         '$product_variant': '',
    //         '$rating_average': 0,
    //         '$rating_max': 0
    //       }
    //       content_items.push(obj)
    //     })
    //     console.info('+++++++++++++addCommerceEvent event_and_custom_data ++++++++++++++')
    //     console.info(event_and_custom_data)
    //     console.info('+++++++++++++addCommerceEvent content_items ++++++++++++++')
    //     console.info(content_items)
    //     branch.logEvent(type, event_and_custom_data, content_items, 'commerce event alias', function (_error) {

    //       if (_error) {
    //         console.info('+++++++++++++addCommerceEvent error ++++++++++++++')
    //         console.info(_error)
    //       }
    //     })
    //     console.info('+++++++++++++addCommerceEvent end ++++++++++++++')
    //   } catch (error) {
    //     console.info('+++++++++++++addCommerceEvent call API error ++++++++++++++')
    //     console.info(error)
    //   }
    // },

    /**
     * tracking all page
     * @param pageInfo is a object includes name and type
     *  sample { 'name': 'homepage.home',  'type': 'homepage'}
     */
    eventTrackingScreenLoad(vm, pageInfo) {
      console.info('+++++++++++++eventTrackingScreenLoad++++++++++++++')
      let data = {
        'event': 'screen.load.auto.dataLayer.load',
        'screen': pageInfo.screen,
        'platform': this.getFlatformDatalayer(vm),
        'user': {}
      }
      if (pageInfo.modules) {
        data.modules = pageInfo.modules
      }
      if (pageInfo.assets) {
        data.assets = pageInfo.assets
      }
      data.user = this.getUserDatalayer(vm)
      console.info('+++++++++++++eventTrackingScreenLoad data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingScreenLoad end ++++++++++++++')
      dataLayer.push(data)
    },
    /**
     * tracking success localizaion
     */
    eventTrackingLocalisationSuccess(vm) {
      console.info('+++++++++++++eventTrackingLocalisationSuccess++++++++++++++')
      let data = {
        'event': 'user.interact.auto.success.localisationSuccess',
        'cart': this.generateCartBasic(vm)
      }
      console.info('+++++++++++++eventTrackingLocalisationSuccess data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingLocalisationSuccess end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingLocalisationError(data) {
      console.info('+++++++++++++eventTrackingLocalisationError++++++++++++++')
      let layer = {
        'event': 'user.interact.auto.error.localisationError',
        'error': {
          'code': data.code,
          'type': 'geolocation',
          'error': data.error
        }
      }
      console.info('+++++++++++++eventTrackingLocalisationError data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingLocalisationError end ++++++++++++++')
      dataLayer.push(layer)
    },
    /**
     * @param items is list of products
     */
    eventTrackingProductLoad(vm, items, isHalf = false, isList = false) {
      let categoryUuid = vm.$session.get('categoryUuid') || vm.$store.getters.category_uuid
      let cateogry = {}
      let categories = vm.$session.get('listCategory')
      let productids = []
      let products = []
      if (categories.length > 0) {
        for (let i in categories) {
          if (categories[i].uuid == categoryUuid) {
            cateogry = categories[i]
            break
          }
        }
        if (this.empty(cateogry)) {
          cateogry = categories[0]
        }
      }
      if (isHalf) {
        console.info('+++++++++++++eventTrackingProductLoad half ++++++++++++++')
        productids.push(vm.$const.HALF_HALF_UUID)
        products.push({
          'id': vm.$const.HALF_HALF_UUID,
          'name': vm.$t('btn_hatf_halt'),
          'category': 'pizza',
          'variants': [],
          'value': {
            'displayGross': '0',
            'displayTax': '0'
          },
          'tax': {
            'type': '',
            'name': '',
            'size': ''
          },
          'purchaseMethod': 'main',
          'bundleItems': []
        })
      } else {
        if (!isList) {
          console.info('+++++++++++++eventTrackingProductLoad menu single ++++++++++++++')
          productids.push(items.uuid)
          products.push({
            id: items.uuid,
            name: this.convertStringSnakeCase(items.name),
            category: cateogry.name,
            variants: [],
            value: {
              displayGross: items.price || items.min_price,
              displayTax: 0
            },
            tax: {
              type: '',
              name: '',
              size: ''
            },
            purchaseMethod: 'main',
            bundleItems: []
          })
        } else {
          console.info('+++++++++++++eventTrackingProductLoad list ++++++++++++++')
          if (items && items.length > 0) {
            for (let i in items) {
              let menus = items[i].singles
              if (menus.length > 0) {
                for (let m in menus) {
                  productids.push(menus[m].uuid)
                  products.push({
                    id: menus[m].uuid,
                    name: this.convertStringSnakeCase(menus[m].name),
                    category: cateogry.name,
                    variants: [],
                    value: {
                      displayGross: menus[m].price || menus[m].min_price,
                      displayTax: 0
                    },
                    tax: {
                      type: '',
                      name: '',
                      size: ''
                    },
                    purchaseMethod: 'main',
                    bundleItems: []
                  })
                }
              }
            }
          }
        }
      }
      let layer = {
        'event': 'product.load.auto.dataLayer.load',
        'products': productids,
        'assets': {
          'products': products
        }
      }
      console.info('+++++++++++++eventTrackingProductLoad data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingProductLoad end ++++++++++++++')
      dataLayer.push(layer)
    },
    /**
     * the event is used for
     * 1 Combo detail: product detail page
     * 2 menu or half & half: product list page ( include all of crust and size)
     * 3 menu or half & half detail page: already add to cart
     * @param item is a product
     */
    eventTrackingProductDetail(vm, item, type, nameType = 'product-list', hideEvent = false, method = 'main') {
      console.info('+++++++++++++eventTrackingProductDetail ++++++++++++++')
      let categoryUuid = vm.$session.get('categoryUuid') || vm.$store.getters.category_uuid
      let cateogry = {}
      let categories = vm.$session.get('listCategory')
      if (categories.length > 0) {
        for (let i in categories) {
          if (categories[i].uuid == categoryUuid) {
            cateogry = categories[i]
            break
          }
        }
        if (this.empty(cateogry)) {
          cateogry = categories[0]
        }
      }
      let cart = this.generateCartBasic(vm, true)
      let variants = []
      let name = ''
      if (type != vm.$const.CARD_ITEM_TYPE.HALF) {
        if (item) {
          if (item.first_layers) {
            for (let f in item.first_layers) {
              let price = item.first_layers[f].price
              if (item.first_layers[f].second_layers != null && item.first_layers[f].second_layers.length > 0) {
                for (let s in item.first_layers[f].second_layers) {
                  price = item.first_layers[f].price + item.first_layers[f].second_layers[s].price
                  variants.push({
                    id: item.first_layers[f].uuid + '-' + item.first_layers[f].second_layers[s].uuid,
                    name: this.convertStringSnakeCase(`${item.name} ${item.first_layers[f].name} ${item.first_layers[f].second_layers[s].name}`),
                    type: 'size-crust',
                    quantity: 1,
                    value: {
                      displayGross: price,
                      displayTax: 0
                    }
                  })
                }
              } else {
                variants.push({
                  id: item.first_layers[f].uuid,
                  name: this.convertStringSnakeCase(`${item.name} ${item.first_layers[f].name}`),
                  type: 'size',
                  quantity: 1,
                  value: {
                    displayGross: price,
                    displayTax: 0
                  }
                })
              }
            }
          }
          name = nameType + '.' + cateogry.slug + '.'
          let _tempMode = item.isMultiple ? 'multiple-item' : 'single-item'
          if (type == vm.$const.CARD_ITEM_TYPE.COMBO) {
            name += _tempMode + '.'
          }
          if (method === 'deal') {
            name = nameType + '.' + cateogry.slug + '.' + _tempMode + '.' + (item.comboName ? item.comboName.split(' ').join('-') : item.comboName) + '.'
          }
          name += item.name ? item.name.split(' ').join('-') : item.name
        }
      } else {
        name = nameType + '.pizza.half-and-half'
        item = {
          id: item.uuid || vm.$const.HALF_HALF_UUID,
          uuid: item.uuid || vm.$const.HALF_HALF_UUID,
          name: item.name || vm.$t('btn_hatf_halt'),
          price: 0
        }
      }
      let flatform = vm.$const.DATA_LAYER.PLATFORM
      flatform.environment = process.env.NODE_ENV
      flatform.localeLanguage = vm.$i18n.locale

      let data = {
        'event': 'screen.load.auto.dataLayer.load',
        'screen': {
          'name': name,
          'type': nameType
        },
        'platform': flatform,
        'user': {},
        'products': [item.uuid],
        'cart': cart,
        'assets': {
          'products': [{
            id: item.uuid,
            name: this.convertStringSnakeCase(item.name),
            category: cateogry.name,
            attributes: {},
            variants: variants,
            'value': {
              'displayGross': item.price,
              'displayTax': 0
            },
            'tax': {
              'type': '',
              'name': '',
              'size': 0
            },
            'purchaseMethod': method
          }]
        }
      }
      data.user = this.getUserDatalayer(vm)
      if (hideEvent) {
        delete data.event
      }
      console.info('+++++++++++++eventTrackingProductDetail data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingProductDetail end ++++++++++++++')
      dataLayer.push(data)
    },
    /**
     *
     */
     eventTrackingProductView(variantUUid = null, product = {}, vm = null) {
      console.info('+++++++++++++eventTrackingProductView data ++++++++++++++')
      console.info('+++++++++++++eventTrackingProductView data ++++++++++++++')
      let item = product.item || product
      let categoryUuid = this.$session.get('categoryUuid') || this.$store.getters.category_uuid
      let category = {}
      let categories = this.$session.get('listCategory')
      if (categories.length > 0) {
        for (let i in categories) {
          if (categories[i].uuid == categoryUuid) {
            category = categories[i]
            break
          }
        }
        if (this.empty(category)) {
          category = categories[0]
        }
      }
      let categoryName = this.getSlugCategoryCurrent(category)
      const name = item.isHalf ? 'Half - Half' : this.convertStringSnakeCase(item.name_en || item.name) || ''
      let products = []
      if (product && vm && product != {} && vm != null) {
        let bundleItems = []
        for (let i in product.combogroup) {
          let menu = product.combogroup[i].item
          let variantOb = {
            quantity: 1,
            'value': {
              'displayGross': 0,
              'displayTax': 0
            }
          }
          let price = menu.price
          let nameMenu = menu.name
          if (menu.hasOwnProperty('choosedFirst') && menu.choosedFirst != null && !vm.empty(menu.choosedFirst)) {
            variantOb.id = menu.choosedFirst.uuid
            variantOb.value.displayGross += menu.choosedFirst.price*1
            price -= menu.choosedFirst.price*1
            variantOb.name = menu.name + '-' + menu.choosedFirst.name
            variantOb.name = menu.name
            if (variantOb.name.indexOf(menu.choosedFirst.name) >= 0) {
              variantOb.name = variantOb.name.replace(menu.choosedFirst.name, '').trim()
              nameMenu = variantOb.name
            }
            variantOb.name += '-' + menu.choosedFirst.name
            variantOb.type = 'size'
          }
          if (menu.hasOwnProperty('choosedSecond') && menu.choosedSecond != null && !vm.empty(menu.choosedSecond)) {
            variantOb.name += '-' + menu.choosedSecond.name
            variantOb.id += '-' + menu.choosedSecond.uuid
            variantOb.type += '-crust'
            variantOb.value.displayGross += menu.choosedSecond.price*1
          }
          variantOb.name = this.convertStringSnakeCase(variantOb.name)
          bundleItems.push({
            productId: menu.uuid,
            category: category.name || '', // not yet from api
            quantity: '1',
            name: this.convertStringSnakeCase(nameMenu),
            purchaseMethod: 'deal',
            variant: variantOb,
            value: {
              displayGross: price,
              displayTax: 0
            }
          })
        }
        products.push({
          'id': item.uuid,
          'name': this.convertStringSnakeCase(item.name),
          'category': item.category || '',
          'attributes': {},
          'variants': [],
          'value': {
            'displayGross': product.price,
            'displayTax': '0.00'
          },
          'tax': {
            'type': '',
            'name': '',
            'size': ''
          },
          'purchaseMethod': 'main',
          'bundleItems': bundleItems
        })
      }
      const layer = {
        'event': 'product.interact.manual.view',
        'variantId': variantUUid || '',
        'products': [
          item.uuid
        ],
        'name': name,
        'id': item.uuid || '',
        'category': categoryName || '',
        'price': item.price || '0',
        'assets': {
          'products': products
        }
      }
      console.info(layer)
      console.info('+++++++++++++eventTrackingProductView end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingAddToCart(vm, item, method = 'main', type = '', interaction = 'direct-product-selection') {
      console.info('+++++++++++++eventTrackingAddToCart ++++++++++++++')
      let categoryUuid = vm.$session.get('categoryUuid') || vm.$store.getters.category_uuid
      let cateogry = {}
      let categories = vm.$session.get('listCategory')
      let _menu = item.item
      if (_menu.item && _menu.item.category) {
        cateogry = vm.lodash.cloneDeep(_menu.item.category)
        let lang = vm.$i18n ? vm.$i18n.locale || vm.$const.LANG_JP : vm.$const.LANG_JP
        if (cateogry.name && cateogry.name[lang] != undefined) {
          cateogry.name = cateogry.name[lang]
        } else {
          cateogry = {}
        }
      }
      if (vm.empty(cateogry) && categories.length > 0) {
        for (let i in categories) {
          if (categories[i].uuid == categoryUuid) {
            cateogry = categories[i]
            break
          }
        }
        if (this.empty(cateogry)) {
          cateogry = categories[0]
        }
      }
      let variants = []
      if (_menu) {
        if (_menu.first_layers) {
          for (let f in _menu.first_layers) {
            let price = _menu.first_layers[f].price
            if (_menu.first_layers[f].second_layers != null && _menu.first_layers[f].second_layers.length > 0) {
              for (let s in _menu.first_layers[f].second_layers) {
                price = _menu.first_layers[f].price + _menu.first_layers[f].second_layers[s].price
                variants.push({
                  id: _menu.first_layers[f].uuid + '-' + _menu.first_layers[f].second_layers[s].uuid,
                  name: this.convertStringSnakeCase(`${_menu.name} ${_menu.first_layers[f].name} ${_menu.first_layers[f].second_layers[s].name}`),
                  type: 'size-crust',
                  quantity: 1,
                  value: {
                    displayGross: price,
                    displayTax: 0
                  }
                })
              }
            } else {
              variants.push({
                id: _menu.first_layers[f].uuid,
                name: this.convertStringSnakeCase(`${_menu.name} ${_menu.first_layers[f].name}`),
                type: 'size',
                quantity: 1,
                value: {
                  displayGross: price,
                  displayTax: 0
                }
              })
            }
          }
        }
      }
      let categoryName = this.getSlugCategoryCurrent(cateogry)
      const name = _menu.isHalf ? 'Half - Half' : this.convertStringSnakeCase(_menu.name_en || _menu.name) || ''

      let layer = {
        'event': 'product.interact.manual.click.addToCart',
        'bundleItems': [],
        'productId': '',
        'variantId': item.variant_uuid || '',
        'name': name,
        'id': _menu.uuid || '',
        'category': categoryName || '',
        'price': _menu.min_price || '0',
        'quantity': '1',
        'context': item.context,
        'assets': {
          'products': [
            {
              'id': _menu.uuid || '',
              'name': name || '',
              'category': categoryName || '',
              'attributes': {},
              'variants': variants,
              'value': {
                'displayGross': _menu.min_price || '0',
                'displayTax': 0
              },
              'tax': {
                'type': '',
                'name': '',
                'size': ''
              },
              'purchaseMethod': 'main'
            }
          ]
        }
      }
      switch (type) {
        case vm.$const.CARD_ITEM_TYPE.SINGLE:
          layer.productId = item.id
          if (typeof item.first !== 'undefined' && !vm.empty(item.first)) {
            layer.variantId = item.first.uuid
            if (typeof item.second !== 'undefined' && !vm.empty(item.second)) {
              layer.variantId += '-' + item.second.uuid
            }
          }
          break
        case vm.$const.CARD_ITEM_TYPE.COMBO:
          layer.productId = item.id
          layer.products = {
            id: item.id,
            name: this.convertStringSnakeCase(item.name),
            category: categoryName || '', // not yet from api
            purchaseMethod: 'deal',
            value: {
              displayGross: item.price,
              displayTax: 0
            },
            bundleItems: {}
          }
          let bundleItems1 = []
          for (let i in item.items) {
            let menu = item.items[i]
            let variantOb = {
              quantity: 1,
              'value': {
                'displayGross': 0,
                'displayTax': 0
              }
            }
            let price = menu.item.price
            let nameMenu = menu.item.name
            if (menu.hasOwnProperty('first') && menu.first != null && !vm.empty(menu.first)) {
              variantOb.id = menu.first.uuid
              // price += menu.first.price
              variantOb.value.displayGross += menu.first.price
              variantOb.name = menu.item.name
              if (variantOb.name.indexOf(menu.first.name) >= 0) {
                variantOb.name = variantOb.name.replace(menu.first.name, '').trim()
                nameMenu = variantOb.name
              }
              variantOb.name += '-' + menu.first.name
              variantOb.type = 'size'
            }
            if (menu.hasOwnProperty('second') && menu.second != null && !vm.empty(menu.second)) {
              variantOb.name += '-' + menu.second.name
              variantOb.id += '-' + menu.second.uuid
              variantOb.type += '-crust'
              // price += menu.second.price
              variantOb.value.displayGross += menu.second.price
            }
            variantOb.name = this.convertStringSnakeCase(variantOb.name)
            bundleItems1.push({
              productId: menu.item.uuid,
              category: menu.item.category || '', // not yet from api
              quantity: '1',
              name: this.convertStringSnakeCase(nameMenu),
              purchaseMethod: 'deal',
              variant: variantOb,
              value: {
                displayGross: price,
                displayTax: 0
              }
            })
          }
          layer.bundleItems = bundleItems1
          layer.products.bundleItems = bundleItems1
          break
        case vm.$const.CARD_ITEM_TYPE.HALF:
          layer.productId = item.id
          let bundleItems = []
          for (let i in item.items) {
            let menu = item.items[i]
            let variantOb = {
              quantity: 1,
              'value': {
                'displayGross': 0,
                'displayTax': 0
              }
            }
            let price = menu.item.price
            if (menu.hasOwnProperty('first') && menu.first != null) {
              variantOb.id = menu.first.uuid
              variantOb.name = menu.item.name + '-' + menu.first.name
              variantOb.type = 'size'
              variantOb.value.displayGross += menu.first.price
            }
            if (menu.hasOwnProperty('second') && menu.second != null) {
              variantOb.name += '-' + menu.second.name
              variantOb.id += '-' + menu.second.uuid
              variantOb.type += '-crust'
              variantOb.value.displayGross += menu.second.price
            }
            variantOb.name = this.convertStringSnakeCase(variantOb.name)
            bundleItems.push({
              productId: menu.item.uuid,
              category: menu.item.category || '', // not yet from api
              quantity: '1',
              name: this.convertStringSnakeCase(menu.item.name),
              purchaseMethod: 'half-half',
              variant: variantOb,
              value: {
                displayGross: price,
                displayTax: 0
              }
            })
          }
          layer.bundleItems = bundleItems
          break
      }
      console.info('+++++++++++++eventTrackingAddToCart data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingAddToCart end ++++++++++++++')
      dataLayer.push(layer)
      this.addCommerceEvent('ADD_TO_CART', item)
    },
    evenTrackingProductClick(vm, item, method = '', type = 1) {
      let variants = []
      if (item) {
        if (item.first_layers) {
          for (let f in item.first_layers) {
            let price = item.first_layers[f].price
            if (item.first_layers[f].second_layers != null && item.first_layers[f].second_layers.length > 0) {
              for (let s in item.first_layers[f].second_layers) {
                price = item.first_layers[f].price + item.first_layers[f].second_layers[s].price
                variants.push({
                  id: item.first_layers[f].uuid + '-' + item.first_layers[f].second_layers[s].uuid,
                  name: this.convertStringSnakeCase(`${item.name} ${item.first_layers[f].name} ${item.first_layers[f].second_layers[s].name}`),
                  type: 'size-crust',
                  quantity: 1,
                  value: {
                    displayGross: price,
                    displayTax: 0
                  }
                })
              }
            } else {
              variants.push({
                id: item.first_layers[f].uuid,
                name: this.convertStringSnakeCase(`${item.name} ${item.first_layers[f].name}`),
                type: 'size',
                quantity: 1,
                value: {
                  displayGross: price,
                  displayTax: 0
                }
              })
            }
          }
        }
      }
      let categoryUuid = vm.$session.get('categoryUuid') || vm.$store.getters.category_uuid
      let cateogry = {}
      let categories = vm.$session.get('listCategory')
      if (item.item && item.item.category) {
        cateogry = vm.lodash.cloneDeep(item.item.category)
        let lang = vm.$i18n ? vm.$i18n.locale || vm.$const.LANG_JP : vm.$const.LANG_JP
        if (cateogry.name && cateogry.name[lang] != undefined) {
          cateogry.name = cateogry.name[lang]
        } else {
          cateogry = {}
        }
      }

      if (vm.empty(cateogry) && categories && categories.length > 0 ) {
        for (let i in categories) {
          if (categories[i].uuid == categoryUuid) {
            cateogry = categories[i]
            break
          }
        }
        if (this.empty(cateogry)) {
          cateogry = categories[0]
        }
      }
      const categoryName = this.getSlugCategoryCurrent(cateogry)
      const name = item.isHalf ? 'Half - Half' : this.convertStringSnakeCase(item.name_en || item.name) || ''
      let data = {
        'event': 'product.interact.manual.click',
        'interactionElement': {
          'method': method
        },
        'products': [item.uuid],
        'productId': item.uuid,
        'variantId': item.variant_uuid || '',
        'name': name,
        'id': item.id || '',
        'category': categoryName || '',
        'price': item.price > 0 ? item.price : (item.min_price || '0'),
        'assets': {
          'products': [
            {
              'id': item.uuid || '',
              'name': this.convertStringSnakeCase(item.name) || '',
              'category': cateogry.name || '',
              'attributes': {},
              'variants': variants,
              'value': {
                'displayGross': item.min_price || '0',
                'displayTax': 0
              },
              'tax': {
                'type': '',
                'name': '',
                'size': ''
              },
              'purchaseMethod': 'main'
            }
          ]
        }
      }
      console.info('+++++++++++++evenTrackingProductClick data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++evenTrackingProductClick end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingAddToDeal(vm, item) {
      console.info('+++++++++++++eventTrackingAddToDeal ++++++++++++++')
      let categoryUuid = vm.$session.get('categoryUuid') || vm.$store.getters.category_uuid
      let cateogry = {}
      let categories = vm.$session.get('listCategory')
      if (categories.length > 0) {
        for (let i in categories) {
          if (categories[i].uuid == categoryUuid) {
            cateogry = categories[i]
            break
          }
        }
        if (this.empty(cateogry)) {
          cateogry = categories[0]
        }
      }
      let variants = []
      if (typeof item.first !== 'undefined' && !vm.empty(item.first)) {
        let variant = {}
        let price = item.first.price
        variant.id = item.first.uuid
        variant.name = item.name + '-' + item.first.name
        variant.type = 'size'
        if (typeof item.second !== 'undefined' && !vm.empty(item.second)) {
          variant.id += '-' + item.second.uuid
          variant.type += '-crust'
          variant.name += '-' + item.second.name
          price += item.second.price
        }

        variant.name = this.convertStringSnakeCase(variant.name)
        variant.value = {
          displayGross: price,
          displayTax: 0
        }
        variants.push(variant)
      }

      let menu = item.item
      let variantsData = []
      if (menu) {
        if (menu.first_layers) {
          for (let f in menu.first_layers) {
            let price1 = menu.first_layers[f].price
            if (menu.first_layers[f].second_layers != null && menu.first_layers[f].second_layers.length > 0) {
              for (let s in menu.first_layers[f].second_layers) {
                price1 = menu.first_layers[f].price + menu.first_layers[f].second_layers[s].price
                variantsData.push({
                  id: menu.first_layers[f].uuid + '-' + menu.first_layers[f].second_layers[s].uuid,
                  name: this.convertStringSnakeCase(`${menu.name} ${menu.first_layers[f].name} ${menu.first_layers[f].second_layers[s].name}`),
                  type: 'size-crust',
                  quantity: 1,
                  value: {
                    displayGross: price1,
                    displayTax: 0
                  }
                })
              }
            } else {
              variantsData.push({
                id: menu.first_layers[f].uuid,
                name: this.convertStringSnakeCase(`${menu.name} ${menu.first_layers[f].name}`),
                type: 'size',
                quantity: 1,
                value: {
                  displayGross: price1,
                  displayTax: 0
                }
              })
            }
          }
        }
      }

      let data = {
        'event': 'product.interact.manual.click',
        'products': [{
          'id': item.combo_uuid,
          'bundleItems': [
            {
              'id': item.id,
              'name': this.convertStringSnakeCase(item.name),
              'category': cateogry.name,
              'attributes': {},
              'variants': variants,
              'value': {
                'displayGross': item.price,
                'displayTax': 0
              },
              'tax': {
                'type': '',
                'name': '',
                'size': ''
              },
              'purchaseMethod': 'deal'
            }
          ]
        }],
        'assets': {
          'products': [
            {
              'id': menu.uuid || '',
              'name': this.convertStringSnakeCase(menu.name) || '',
              'category': cateogry.name || '',
              'attributes': {},
              'variants': variantsData,
              'value': {
                'displayGross': menu.min_price || '0',
                'displayTax': 0
              },
              'tax': {
                'type': '',
                'name': '',
                'size': ''
              },
              'purchaseMethod': 'main'
            }
          ]
        }
      }
      console.info('+++++++++++++eventTrackingAddToDeal data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingAddToDeal end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingRemoveFromCart(vm, item) {
      console.info('+++++++++++++eventTrackingRemoveFromCart++++++++++++++')
      let categoryUuid = vm.$session.get('categoryUuid') || vm.$store.getters.category_uuid
      let cateogry = {}
      let categories = vm.$session.get('listCategory')
      if (item && item.category) {
        cateogry = vm.lodash.cloneDeep(item.category)
        let lang = vm.$i18n ? vm.$i18n.locale || vm.$const.LANG_JP : vm.$const.LANG_JP
        if (cateogry.name && cateogry.name[lang] != undefined) {
          cateogry.name = cateogry.name[lang]
        } else {
          cateogry = {}
        }
      }
      if (vm.empty(cateogry) && categories.length > 0) {
        for (let i in categories) {
          if (categories[i].uuid == categoryUuid) {
            cateogry = categories[i]
            break
          }
        }
        if (this.empty(cateogry)) {
          cateogry = categories[0]
        }
      }
      let categoryName = this.getSlugCategoryCurrent(cateogry)
      const name = item.isHalf ? 'Half - Half' : this.convertStringSnakeCase(item.name_en || item.name) || ''
      let data = {
        'event': 'product.interact.manual.click.removeFromCart',
        'product': {
          'id': item.id,
          'variants': item.variants,
          'quantity': item.quantity
        },
        'id': item.id,
        'variants': item.variants,
        'name': name,
        'category': categoryName || '',
        'price': item.price || '0',
      }
      console.info('+++++++++++++eventTrackingRemoveFromCart data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingRemoveFromCart end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingUpdateQuantityFromCart(item) {
      console.info('+++++++++++++addToCart++++++++++++++')
      let data = {
        'event': 'product.interact.manual.click.addToCart',
        'interactionElement': {'method': 'quantity-increase'},
        'productId': item.id,
        'variantId': item.variantId,
        'quantity': item.quantity
      }
      console.info('+++++++++++++addToCart data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++addToCart end ++++++++++++++')
      dataLayer.push(data)
    },
    /**
     * @param variant is a menu
     *  {
          "id": "crispy-bacon",
          "productId": "pepperoni-feast",
          "type": "topping",
          "name": "crispy-bacon",
          "value": {
            "displayGross": "1.20",
            "displayTax": "0.24"
          }
        }
     */
    eventTrackingVariantSelect(item) {
      console.info('+++++++++++++eventTrackingVariantSelect ++++++++++++++')
      let topping = item.topping
      let first = item.first
      let price = 0
      if (topping) {
        price = topping.prices != null && topping.prices.hasOwnProperty(first.sku) ? topping.prices[first.sku] : 0
      } else {
        price = 0
      }

      let data = {
        'event': 'variant.interact.manual.click.select',
        'variant': {
          'id': topping ? topping.uuid : '',
          'productId': item.item ? item.item.uuid : '',
          'type': 'topping',
          'name': topping ? this.convertStringSnakeCase(topping.name) : '',
          'value': {
            'displayGross': price,
            'displayTax': '0'
          }
        }
      }
      console.info('+++++++++++++eventTrackingVariantSelect data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingVariantSelect end ++++++++++++++')
      dataLayer.push(data)
    },
    /**
     * @param variant is a menu
     *  {
          "id": "crispy-bacon",
          "productId": "pepperoni-feast",
          "type": "topping",
          "name": "crispy-bacon",
          "value": {
            "displayGross": "1.20",
            "displayTax": "0.24"
          }
        }
     */
    eventTrackingVariantUnSelect(item) {
      console.info('+++++++++++++eventTrackingVariantUnSelect++++++++++++++')
      let topping = item.topping
      let first = item.first
      let price = 0
      if (topping) {
        price = topping.prices != null && topping.prices.hasOwnProperty(first.sku) ? topping.prices[first.sku] : 0
      } else {
        price = 0
      }
      let data = {
        'event': 'variant.interact.manual.click.unselect',
        'variant': {
          'id': topping ? topping.uuid : '',
          'productId': item.item ? item.item.uuid : '',
          'type': 'topping',
          'name': topping ? topping.name : '',
          'value': {
            'displayGross': price,
            'displayTax': '0'
          }
        }
      }
      console.info('+++++++++++++eventTrackingVariantUnSelect data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingVariantUnSelect end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingCheckout(vm) {
      console.info('+++++++++++++eventTrackingCheckout++++++++++++++')
      let cart = this.generateCartFullForCheckout(vm)
      cart.checkoutStep = 1
      let data = {
        'event': 'screen.load.auto.dataLayer.load',
        'screen': {
          'name': 'checkout.details',
          'type': 'checkout'
        },
        'cart': cart,
        'user': this.getUserDatalayer(vm),
        'platform': this.getFlatformDatalayer(vm)
      }
      console.info('+++++++++++++eventTrackingCheckout data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingCheckout end ++++++++++++++')
      dataLayer.push(data)
      this.addCommerceEvent('INITIAL_PURCHASE')
    },
    eventTrackingPayment(vm, form) {
      console.info('+++++++++++++eventTrackingPayment ++++++++++++++')
      let cart = this.generateCartFullForCheckout(vm)
      cart.checkoutStep = 2
      let data = {
        'event': 'screen.load.auto.dataLayer.load',
        'screen': {
          'name': 'checkout.payment',
          'type': 'checkout'
        },
        'forms': [form.id],
        'cart': cart,
        'assets': form
      }
      console.info('+++++++++++++eventTrackingPayment data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingPayment end ++++++++++++++')
      dataLayer.push(data)
    },
    /**
     * for order status page
     * @param data
     * @param orderTime
     * @returns {{id: string, checkoutStep: string, currency: *, discount: {lines: Array, value: {displayGross: *, displayTax: string}}, shipping: {value: {displayGross: *, displayTax: string}, type: string, storeId: *, deliveryTime: *}, value: {displayGross: number | string | * | PaymentItem, displayTax: number}}}
     */
    genCartForConfirmation(vm, data, orderTime) {
      let cart = {
        'id': data.uuid,
        'currency': data.currency,
        'lines': [],
        'discount': {
          lines: [],
          value: {
            'displayGross': data.total_discount, // total discount
            'displayTax': '0.00'
          }
        },
        'shipping': {
          'value': {
            'displayGross': data.delivery_fee || 0,
            'displayTax': '0.00'
          },
          'type': data.order_type.toUpperCase() == 'D' ? vm.$const.DELIVERY.toLowerCase() : 'collection',
          'storeId': data.outlet_code,
          'deliveryTime': orderTime
        },
        'value': {
          'displayGross': data.total || 0, // total cart
          'displayTax': 0
        }
      }
      for (let i in data.order_items) {
        let menu = vm.lodash.cloneDeep(data.order_items[i])
        let item = {}
        let baseCategory = menu.base_category || menu.items[0].base_category
        let categoryName = this.getSlugCategoryCurrent(baseCategory)
        if (menu.type == vm.$const.CARD_ITEM_TYPE.COMBO) {
          item.id = data.uuid + '-' + (parseFloat(i) + 1)
          item.product = {
            'id': menu.uuid || 0,
            'name': this.convertStringSnakeCase(menu.name),
            'category': categoryName,
            'attributes': {},
            'variants': [],
            'value': {
              'displayGross': menu.price,
              'displayTax': '0'
            },
            'tax': {
              'type': '',
              'name': '',
              'size': ''
            },
            'purchaseMethod': 'main',
            'bundleItems': []
          }
          let bundleItems = []
          for (let c in menu.items) {
            let product = vm.lodash.cloneDeep(menu.items[c])
            let variantOb = {
              'value': {
                'displayGross': 0,
                'displayTax': '0'
              }
            }
            let fPrice = 0
            if (product.hasOwnProperty('first') && product.first != null && product.first.sku != '') {
              variantOb.id = product.first.uuid
              fPrice += product.first.price
              variantOb.name = product.name + '-' + product.first.name
              variantOb.type = 'size'
              if (product.first.hasOwnProperty('second') && product.first.second != null && product.first.second.sku != '') {
                variantOb.id = product.first.uuid + '-' + product.first.second.uuid
                variantOb.name += '-' + product.first.second.name
                variantOb.type += '-crust'
                fPrice += product.first.second.price
              }
            }
            variantOb.value.displayGross = fPrice
            variantOb.name = this.convertStringSnakeCase(variantOb.name)
            bundleItems.push({
              productId: product.uuid,
              category: product.category || '', // not yet from api
              quantity: product.quantity,
              name: this.convertStringSnakeCase(product.name),
              purchaseMethod: 'deal',
              variant: variantOb,
              value: {
                displayGross: product.base_price || 0,
                displayTax: 0
              }
            })
          }
          item.product.bundleItems = bundleItems
          item.quantity = menu.quantity
          item.value = {
            'displayGross': menu.total,
            'displayTax': '0'
          }
          item.discount = {
            lines: [],
            'value': {
              'displayGross': '',
              'displayTax': '0'
            }
          }
          if (menu.coupon_code != undefined && menu.coupon_code != null && !this.empty(menu.coupon_code)) {
            item.discount.lines.push(this.getCoupondetail2(menu.coupon_code, data.order_coupons))
          }
          let dprice = 0
          for (let d in item.discount.lines) {
            dprice += parseFloat(item.discount.lines[d].value.displayGross)
          }
          item.discount.value.displayGross = dprice
        } else if (menu.type == vm.$const.CARD_ITEM_TYPE.SINGLE) {
          item.id = data.uuid + '-' + (parseFloat(i) + 1)
          item.product = {
            'id': '',
            'name': '',
            'category': categoryName,
            'attributes': {},
            'variants': [],
            'value': {
              'displayGross': menu.price,
              'displayTax': '0'
            },
            'tax': {
              'type': '',
              'name': '',
              'size': ''
            },
            'purchaseMethod': 'main',
            'bundleItems': []
          }
          item.quantity = menu.quantity
          item.value = {
            'displayGross': menu.total,
            'displayTax': '0'
          }
          item.discount = {
            lines: [],
            'value': {
              'displayGross': '',
              'displayTax': '0'
            }
          }
          for (let v in menu.items) {
            if (v == 0) {
              item.product.id = menu.items[v].uuid
              item.product.name = this.convertStringSnakeCase(menu.items[v].name)
            }
            if (menu.items[v].coupon_code != undefined && menu.items[v].coupon_code != null && !this.empty(menu.items[v].coupon_code)) {
              item.discount.lines.push(this.getCoupondetail2(menu.items[v].coupon_code, data.order_coupons))
            }
            if (typeof menu.items[v].first !== 'undefined' && !this.empty(menu.items[v].first) && menu.items[v].first.sku != '') {
              let variant = {}
              let price = menu.items[v].first.price
              variant.id = menu.items[v].first.uuid
              variant.name = menu.items[v].name + '-' + menu.items[v].first.name
              variant.type = 'size'
              if (typeof menu.items[v].first.second !== 'undefined' && !this.empty(menu.items[v].first.second) && menu.items[v].first.second.sku != '') {
                variant.type += '-crust'
                variant.name += '-' + menu.items[v].first.second.name
                price += menu.items[v].first.second.price
                variant.id = menu.items[v].first.uuid + '-' + menu.items[v].first.second.uuid
              }
              variant.name = this.convertStringSnakeCase(variant.name)
              variant.value = {
                displayGross: price,
                displayTax: 0
              }
              item.product.variants.push(variant)
            }
          }
          let dprice = 0
          for (let d in item.discount.lines) {
            dprice += parseFloat(item.discount.lines[d].value.displayGross)
          }
          item.discount.value.displayGross = dprice
        } else if (menu.type == vm.$const.CARD_ITEM_TYPE.HALF) {
          item.id = data.uuid + '-' + (parseFloat(i) + 1)
          item.product = {
            'id': vm.$const.HALF_HALF_UUID,
            'name': this.convertStringSnakeCase(menu.name),
            'category': categoryName,
            'attributes': {},
            'variants': [],
            'value': {
              'displayGross': menu.price,
              'displayTax': '0'
            },
            'tax': {
              'type': '',
              'name': '',
              'size': ''
            },
            'purchaseMethod': 'main',
            'bundleItems': []
          }
          item.quantity = menu.quantity
          item.value = {
            'displayGross': menu.total,
            'displayTax': '0'
          }
          item.discount = {
            lines: [],
            'value': {
              'displayGross': '',
              'displayTax': '0'
            }
          }
          if (menu.only_lunch) {
            item.product.id = vm.$const.HALF_HALF_LUNCH_UUID
          }
          let bundleItems = []
          for (let v in menu.items) {
            if (typeof menu.items[v].coupon_code != 'undefined' && menu.items[v].coupon_code != null && !this.empty(menu.items[v].coupon_code)) {
              item.discount.lines.push(this.getCoupondetail2(menu.items[v].coupon_code, data.order_coupons))
            }
            let _menu = vm.lodash.cloneDeep(menu.items[v])
            let layerInfo = vm.lodash.cloneDeep(_menu)
            let variantOb = {
              quantity: 1,
              'value': {
                'displayGross': 0,
                'displayTax': 0
              }
            }
            let price = _menu.base_price || 0
            if (layerInfo.hasOwnProperty('first') && layerInfo.first != null && layerInfo.first.sku != '') {
              variantOb.id = layerInfo.first.uuid
              variantOb.name = _menu.name + '-' + layerInfo.first.name
              variantOb.type = 'size'
              variantOb.value.displayGross += layerInfo.first.price
              if (layerInfo.first.hasOwnProperty('second') && layerInfo.first.second != null && layerInfo.first.second.sku != '') {
                variantOb.name += '-' + layerInfo.first.second.name
                variantOb.id += '-' + layerInfo.first.second.uuid
                variantOb.type += '-crust'
                variantOb.value.displayGross += layerInfo.first.second.price
              }
            }

            variantOb.name = this.convertStringSnakeCase(variantOb.name)
            bundleItems.push({
              productId: _menu.uuid,
              category: _menu.category || '', // not yet from api
              quantity: '1',
              name: this.convertStringSnakeCase(_menu.name),
              purchaseMethod: 'half-half',
              variant: variantOb,
              value: {
                displayGross: price,
                displayTax: 0
              }
            })
          }
          item.product.bundleItems = bundleItems
          let dprice = 0
          for (let d in item.discount.lines) {
            dprice += parseFloat(item.discount.lines[d].value.displayGross)
          }
          item.discount.value.displayGross = dprice
        }
        cart.lines.push(item)
      }

      if (data.order_coupons) {
        for (let c in data.order_coupons) {
          if (data.order_coupons[c].type != vm.$const.COUPON_TYPE_ITEM) {
            cart.discount.lines.push({
              id: data.order_coupons[c].coupon_uuid,
              name: this.convertStringSnakeCase(data.order_coupons[c].coupon_name),
              code: data.order_coupons[c].coupon_code,
              type: data.order_coupons[c].discount_type_name,
              size: data.order_coupons[c].discount_percent_unit || 0,
              value: {
                'displayGross': data.order_coupons[c].discount,
                'displayTax': '0.00'
              }
            })
          }
        }
      }
      return cart
    },
    eventTrackingConfirmation(vm, cart) {
      console.info('+++++++++++++eventTrackingConfirmation ++++++++++++++')
      let timezone = cart.timezone
      let orderTime = this.convertUTCToTimeZone(cart.collection_time, timezone)
      let data = {
        'event': 'screen.load.auto.dataLayer.load',
        'user': this.getUserDatalayer(vm),
        'screen': {
          'name': 'checkout.confirmation',
          'type': 'checkout'
        },
        'transaction': {
          id: cart.uuid,
          currency: cart.currency,
          order_id: cart.order_number,
          cart: this.genCartForConfirmation(vm, cart, orderTime.unix()),
          value: {
            'displayGross': cart.total || 0,
            'displayTax': 0
          },
          payment: {
            id: cart.order_payment.id,
            authId: '',
            type: cart.order_payment.method,
            timestamp: orderTime.unix()
          }
        }
      }
      console.info('+++++++++++++eventTrackingConfirmation data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingConfirmation end ++++++++++++++')
      dataLayer.push(data)

    },
    eventTrackingOrderSubmit(id) {
      let data = {
        'event': 'cart.interact.manual.submit.orderSubmit',
        'cart': id
      }
      dataLayer.push(data)
      this.addCommerceEvent('PURCHASE')
    },
    eventTrackingOrderError(data) {
      console.info('+++++++++++++eventTrackingOrderError ++++++++++++++')
      let layer = {
        'event': 'cart.load.auto.error.orderError',
        'cart': {
          'id': data.id
        },
        'error': {
          'code': data.code,
          'type': data.type,
          'message': data.message
        }
      }
      console.info('+++++++++++++eventTrackingOrderError data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingOrderError end ++++++++++++++')
      dataLayer.push(layer)
      this.addCustomEvent('PURCHASE_FAILURE', 'PURCHASE FAILURE')
    },
    eventTrackingContactus(contactus) {
      console.info('+++++++++++++eventTrackingContactus ++++++++++++++')
      let data = {
        'screen': {
          'name': 'contact-us.contact-us',
          'type': 'contact-us'
        },
        'forms': [
          contactus.id
        ],
        'assets': {
          'forms': [
            contactus
          ]
        }
      }
      console.info('+++++++++++++eventTrackingContactus data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingContactus end ++++++++++++++')
      dataLayer.push(data)
    },
    /**
     *
     * @param data
     */
    eventTrackingModuleLoad(data) {
      console.info('+++++++++++++eventTrackingModuleLoad ++++++++++++++')
      let layer = {
        'event': 'module.load.auto.dataLayer.load',
        'module': {
          'id': data.id,
          'name': data.name,
          'type': data.type,
          'placement': data.placement,
          'items': data.items || []
        },
        'assets': data.assets || {}
      }
      console.info('+++++++++++++eventTrackingModuleLoad data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingModuleLoad end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingCoupon(vm, data) {
      vm.$cart.init(vm)
      console.info('+++++++++++++eventTrackingCoupon++++++++++++++')
      let layer = {
        'event': 'cart.interact.manual.submit.promoCodeAdded',
        'discountLine': {
          'cartId': vm.cart.uuid || 0,
          'id': 'cart-disc-123',
          'name': data.name,
          'type': 'fixed',
          'size': data.price,
          'value': {
            'displayGross': data.price,
            'displayTax': '0.00'
          },
          'code': data.couponCode,
          'category': 'listed'
        }
      }
      console.info('+++++++++++++eventTrackingCoupon data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingCoupon end ++++++++++++++')
      dataLayer.push(layer)
    },
    /**
     *
     * @param data
     */
    eventTrackingModuleItemClick(data) {
      console.info('+++++++++++++eventTrackingModuleItemClick data ++++++++++++++')
      let layer = {
        'event': 'moduleItem.interact.manual.click',
        'moduleItem': {
          'id': data.id,
          'moduleId': data.moduleId
        }
      }
      console.info('+++++++++++++eventTrackingModuleItemClick data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingModuleItemClick end ++++++++++++++')
      dataLayer.push(layer)
    },
    getCoupondetail(code, data) {
      let coupon = {}
      for (let c1 in data) {
        if (data[c1].code == code) {
          coupon = {
            id: data[c1].coupon_uuid,
            name: this.convertStringSnakeCase(data[c1].name),
            type: data[c1].discount_type_name,
            size: data[c1].discount_percent_unit || 0,
            'value': {
              'displayGross': data[c1].discount_value,
              'displayTax': '0'
            },
            code: data[c1].code
          }
          break
        }
      }
      return coupon
    },
    getCoupondetail2(code, data) {
      let coupon = {}
      for (let c1 in data) {
        if (data[c1].coupon_code == code) {
          coupon = {
            id: data[c1].coupon_uuid,
            name: this.convertStringSnakeCase(data[c1].coupon_name),
            type: data[c1].discount_type_name,
            size: data[c1].discount_percent_unit || 0,
            'value': {
              'displayGross': data[c1].discount,
              'displayTax': '0'
            },
            code: data[c1].coupon_code
          }
          break
        }
      }
      return coupon
    },
    generateCartFullForCheckout(vm) {
      vm.$cart.init(vm)
      let cart = {
        'id': vm.cart.uuid,
        'currency': vm.$const.CURRENCY_CODE,
        'shipping': {
          'value': {
            'displayGross': vm.cart.delivery_fee || 0,
            'displayTax': '0.00'
          },
          'discount': {},
          'type': vm.$disposition.getByKey(vm, 'orderType', '').toLowerCase(),
          'storeId': vm.$disposition.getByKey(vm, 'outletCode', ''),
          'deliveryTime': this.getTimePickerDateNoneConvert(vm).unix()
        },
        'value': {
          'displayGross': vm.cart.total || 0,
          'displayTax': 0
        }
      }
      cart.lines = []
      for (let i in vm.cart.data) {
        let menu = vm.lodash.cloneDeep(vm.cart.data[i])
        let item = {}
        let categoryName = this.getSlugCategoryCurrent(menu.base_category)
        if (menu.product_type == vm.$const.CARD_ITEM_TYPE.COMBO) {
          item.id = vm.cart.uuid + '-' + (parseFloat(i) + 1)
          item.product = {
            'id': menu.combo_uuid,
            'name': this.convertStringSnakeCase(menu.name),
            'category': categoryName,
            'attributes': {},
            'variants': [],
            'value': {
              'displayGross': menu.item_price,
              'displayTax': '0'
            },
            'tax': {
              'type': '',
              'name': '',
              'size': ''
            },
            'purchaseMethod': 'main',
            'bundleItems': []
          }
          item.quantity = menu.quantity
          item.value = {
            'displayGross': menu.total,
            'displayTax': '0'
          }
          item.discount = {
            lines: [],
            'value': {
              'displayGross': '',
              'displayTax': '0'
            }
          }
          if (menu.coupon_code != null && !this.empty(menu.coupon_code)) {
            item.discount.lines.push(this.getCoupondetail(menu.coupon_code, vm.cart.coupon.data || []))
          }
          let bundleItems = []
          for (let c in menu.items) {
            for (let j in menu.items[c].group_items) {
              let layerInfo = vm.lodash.cloneDeep(menu.items[c].group_items[j].layer_info)
              let variantOb = {
                quantity: 1,
                'value': {
                  'displayGross': '0',
                  'displayTax': '0'
                }
              }
              let price = 0
              if (layerInfo.hasOwnProperty('first') && layerInfo.first != null) {
                price = layerInfo.first.price
                variantOb.id = layerInfo.first.uuid
                variantOb.name = menu.items[c].group_items[j].name + '-' + layerInfo.first.name
                variantOb.type = 'size'
              }
              if (layerInfo.hasOwnProperty('second') && layerInfo.second != null) {
                variantOb.id += '-' + layerInfo.second.uuid
                variantOb.name += '-' + layerInfo.second.name
                variantOb.type += '-crust'
                price += layerInfo.second.price
              }
              variantOb.name = this.convertStringSnakeCase(variantOb.name)
              variantOb.value.displayGross = price
              bundleItems.push({
                productId: menu.items[c].group_items[j].product_uuid,
                category: menu.items[c].group_items[j].category || '', // not yet from api
                quantity: '1',
                name: this.convertStringSnakeCase(menu.items[c].group_items[j].name),
                purchaseMethod: 'deal',
                variants: [variantOb],
                value: {
                  displayGross: menu.items[c].group_items[j].base_price || 0,
                  displayTax: 0
                }
              })
            }
          }
          item.product.bundleItems = bundleItems
        } else if (menu.product_type == vm.$const.CARD_ITEM_TYPE.SINGLE) {
          item.id = vm.cart.uuid + '-' + (parseFloat(i) + 1)
          item.product = {
            'id': '',
            'name': '',
            'category': categoryName,
            'attributes': {},
            'variants': [],
            'value': {
              'displayGross': menu.item_price,
              'displayTax': '0'
            },
            'tax': {
              'type': '',
              'name': '',
              'size': ''
            },
            'purchaseMethod': 'main',
            'bundleItems': []
          }
          item.quantity = menu.quantity
          item.value = {
            'displayGross': menu.total,
            'displayTax': '0'
          }
          item.discount = {
            lines: [],
            'value': {
              'displayGross': '',
              'displayTax': '0'
            }
          }
          if (menu.coupon_code != null && !this.empty(menu.coupon_code)) {
            item.discount.lines.push(this.getCoupondetail(menu.coupon_code, vm.cart.coupon.data || []))
          }
          for (let v in menu.items) {
            if (v == 0) {
              item.product.id = menu.items[v].product_uuid
              item.product.name = this.convertStringSnakeCase(menu.items[v].name)
            }
            if (typeof menu.items[v].layer_info.first !== 'undefined' && !vm.empty(menu.items[v].layer_info.first)) {
              let variant = {}
              let price = menu.items[v].layer_info.first.price
              variant.id = menu.items[v].layer_info.first.uuid
              variant.name = menu.items[v].name + '-' + menu.items[v].layer_info.first.name
              variant.type = 'size'
              if (typeof menu.items[v].layer_info.second !== 'undefined' && !vm.empty(menu.items[v].layer_info.second)) {
                variant.type += '-crust'
                variant.name += '-' + menu.items[v].layer_info.second.name
                price += menu.items[v].layer_info.second.price
                variant.id += '-' + menu.items[v].layer_info.second.uuid
              }
              variant.name = this.convertStringSnakeCase(variant.name)
              variant.value = {
                displayGross: price,
                displayTax: 0
              }
              item.product.variants.push(variant)
            }
          }
        } else if (menu.product_type == vm.$const.CARD_ITEM_TYPE.HALF) {
          item.id = vm.cart.uuid + '-' + (parseFloat(i) + 1)
          item.product = {
            'id': vm.$const.HALF_HALF_UUID,
            'name': this.convertStringSnakeCase(menu.name),
            'category': categoryName,
            'attributes': {},
            'variants': [],
            'value': {
              'displayGross': menu.item_price,
              'displayTax': '0'
            },
            'tax': {
              'type': '',
              'name': '',
              'size': ''
            },
            'purchaseMethod': 'main',
            'bundleItems': []
          }
          if (menu.only_lunch) {
            item.product.id = vm.$const.HALF_HALF_LUNCH_UUID
          }
          item.quantity = menu.quantity
          item.value = {
            'displayGross': menu.total,
            'displayTax': '0'
          }
          item.discount = {
            lines: [],
            'value': {
              'displayGross': '',
              'displayTax': '0'
            }
          }
          let bundleItems = []
          for (let i in menu.items) {
            let _menu = vm.lodash.cloneDeep(menu.items[i])
            let layerInfo = vm.lodash.cloneDeep(_menu.layer_info)
            let variantOb = {
              quantity: 1,
              'value': {
                'displayGross': 0,
                'displayTax': 0
              }
            }
            let price = _menu.base_price || 0
            if (layerInfo.hasOwnProperty('first') && layerInfo.first != null) {
              variantOb.id = layerInfo.first.uuid
              variantOb.name = _menu.name + '-' + layerInfo.first.name
              variantOb.type = 'size'
              variantOb.value.displayGross += layerInfo.first.price
            }
            if (layerInfo.hasOwnProperty('second') && layerInfo.second != null) {
              variantOb.name += '-' + layerInfo.second.name
              variantOb.id += '-' + layerInfo.second.uuid
              variantOb.type += '-crust'
              variantOb.value.displayGross += layerInfo.second.price
            }
            variantOb.name = this.convertStringSnakeCase(variantOb.name)
            bundleItems.push({
              productId: _menu.product_uuid,
              category: _menu.category || '', // not yet from api
              quantity: '1',
              name: this.convertStringSnakeCase(_menu.name),
              purchaseMethod: 'half-half',
              variant: variantOb,
              value: {
                displayGross: price,
                displayTax: 0
              }
            })
          }
          item.product.bundleItems = bundleItems
          if (menu.coupon_code != null && !this.empty(menu.coupon_code)) {
            item.discount.lines.push(this.getCoupondetail(menu.coupon_code, vm.cart.coupon.data || []))
          }
        }
        cart.lines.push(item)
      }
      cart.discount = {
        lines: [],
        value: {
          'displayGross': '0.00',
          'displayTax': '0.00'
        }
      }
      if (vm.cart.coupon) {
        cart.discount.value.displayGross = vm.cart.coupon.total_discount
        if (vm.cart.coupon.data) {
          for (let c in vm.cart.coupon.data) {
            if (vm.cart.coupon.data[c].discount_type != vm.$const.COUPON_TYPE_ITEM) {
              cart.discount.lines.push({
                id: vm.cart.coupon.data[c].coupon_uuid,
                name: this.convertStringSnakeCase(vm.cart.coupon.data[c].name),
                code: vm.cart.coupon.data[c].code,
                type: vm.cart.coupon.data[c].discount_type_name,
                size: vm.cart.coupon.data[c].discount_percent_unit || 0,
                value: {
                  'displayGross': vm.cart.coupon.data[c].discount_value,
                  'displayTax': '0.00'
                }
              })
            }
          }
        }
      }
      return cart
    },
    generateCartBasic(vm, includeProducts, includeDiscount) {
      vm.$cart.init(vm)
      let cartData = vm.lodash.cloneDeep(vm.cart)
      let cart = {
        'id': cartData.uuid,
        'currency': vm.$const.CURRENCY_CODE,
        'shipping': {
          'value': {
            'displayGross': cartData.delivery_fee || 0,
            'displayTax': '0.00'
          },
          'discount': {},
          'type': vm.$disposition.getByKey(vm, 'orderType', '').toLowerCase(),
          'storeId': vm.$disposition.getByKey(vm, 'outletCode', ''),
          'deliveryTime': this.getTimePickerDateNoneConvert(vm).unix()
        },
        'value': {
          'displayGross': cartData.total || 0,
          'displayTax': cartData.tax_total || 0
        }
      }
      if (includeProducts) {
        cart.lines = []
        for (let i in cartData.data) {
          let menu = vm.lodash.cloneDeep(cartData.data[i])
          let item = {
            id: cartData.uuid + '-' + (parseFloat(i) + 1),
            product: {},
            quantity: menu.quantity,
            value: {
              'displayGross': menu.total,
              'displayTax': 0
            }
          }
          let categoryName = this.getSlugCategoryCurrent(menu.base_category)
          if (menu.product_type == vm.$const.CARD_ITEM_TYPE.COMBO) {
            let bundleItems = []
            item.product.id = menu.combo_uuid
            item.product.name = this.convertStringSnakeCase(menu.name)
            item.product.category = categoryName
            item.product.attributes = {}
            item.product.purchaseMethod = 'main'
            item.product.bundleItems = []
            item.product.tax = {
              'type': '',
              'name': '',
              'size': ''
            }
            item.product.value = {
              displayGross: menu.item_price,
              displayTax: 0
            }
            item.product.variants = []
            for (let c in menu.items) {
              for (let j in menu.items[c].group_items) {
                let layerInfo = vm.lodash.cloneDeep(menu.items[c].group_items[j].layer_info)
                let variantOb = {
                  quantity: 1,
                  'value': {
                    'displayGross': 0,
                    'displayTax': 0
                  }
                }
                if (layerInfo.hasOwnProperty('first') && layerInfo.first != null) {
                  variantOb.id = layerInfo.first.uuid
                  variantOb.name = menu.items[c].group_items[j].name + '-' + layerInfo.first.name
                  variantOb.type = 'size'
                  variantOb.value.displayGross += layerInfo.first.price
                }
                if (layerInfo.hasOwnProperty('second') && layerInfo.second != null) {
                  variantOb.name += '-' + layerInfo.second.name
                  variantOb.id += '-' + layerInfo.second.uuid
                  variantOb.type += '-crust'
                  variantOb.value.displayGross += layerInfo.second.price
                }
                variantOb.name = this.convertStringSnakeCase(variantOb.name)
                bundleItems.push({
                  productId: menu.items[c].group_items[j].product_uuid,
                  category: menu.items[c].group_items[j].category || '', // not yet from api
                  quantity: '1',
                  name: this.convertStringSnakeCase(menu.items[c].group_items[j].name),
                  purchaseMethod: 'deal',
                  variant: variantOb,
                  value: {
                    displayGross: menu.items[c].group_items[j].base_price || 0,
                    displayTax: 0
                  }
                })
              }
            }
            item.product.bundleItems = bundleItems
          } else if (menu.product_type == vm.$const.CARD_ITEM_TYPE.SINGLE) {
            item.product.id = ''
            item.product.name = ''
            item.product.category = categoryName
            item.product.attributes = {}
            item.product.purchaseMethod = 'main'
            item.product.bundleItems = []
            item.product.tax = {
              'type': '',
              'name': '',
              'size': ''
            }
            item.product.value = {
              displayGross: menu.item_price,
              displayTax: 0
            }
            item.product.variants = []
            let datamenu = vm.lodash.cloneDeep(menu.items)
            for (let v in datamenu) {
              if (v == 0) {
                item.product.id = datamenu[v].product_uuid
                item.product.name = this.convertStringSnakeCase(datamenu[v].name)
              }
              let layerInfo = vm.lodash.cloneDeep(datamenu[v].layer_info)

              if (typeof layerInfo.first !== 'undefined' && !vm.empty(layerInfo.first)) {
                let variant = {}
                let price = layerInfo.first.price
                variant.id = layerInfo.first.uuid
                variant.name = datamenu[v].name + '-' + layerInfo.first.name
                variant.type = 'size'
                if (typeof layerInfo.second !== 'undefined' && !vm.empty(layerInfo.second)) {
                  variant.type += '-crust'
                  variant.name += '-' + layerInfo.second.name
                  price += layerInfo.second.price
                  variant.id += '-' + layerInfo.second.uuid
                }
                variant.name = this.convertStringSnakeCase(variant.name)
                variant.value = {
                  displayGross: price,
                  displayTax: 0
                }
                item.product.variants.push(variant)
              }
            }
          } else if (menu.product_type == vm.$const.CARD_ITEM_TYPE.HALF) {
            item.product.id = ''
            item.product.name = ''
            item.product.category = categoryName
            item.product.attributes = {}
            item.product.purchaseMethod = 'main'
            item.product.bundleItems = []
            item.product.tax = {
              'type': '',
              'name': '',
              'size': ''
            }
            item.product.value = {
              displayGross: menu.item_price,
              displayTax: 0
            }
            item.product.variants = []
            item.product.id = vm.$const.HALF_HALF_UUID
            if (menu.only_lunch) {
              item.product.id = vm.$const.HALF_HALF_LUNCH_UUID
            }
            item.product.name = this.convertStringSnakeCase(menu.name)
            let bundleItems = []
            let datamenu = vm.lodash.cloneDeep(menu.items)
            for (let i in datamenu) {
              let _menu = vm.lodash.cloneDeep(datamenu[i])
              let layerInfo = vm.lodash.cloneDeep(_menu.layer_info)
              let variantOb = {
                quantity: 1,
                'value': {
                  'displayGross': 0,
                  'displayTax': 0
                }
              }
              let price = _menu.price || 0
              if (layerInfo.hasOwnProperty('first') && layerInfo.first != null) {
                variantOb.id = layerInfo.first.uuid
                price += layerInfo.first.price
                variantOb.name = _menu.name + '-' + layerInfo.first.name
                variantOb.type = 'size'
                variantOb.value.displayGross += layerInfo.first.price
              }
              if (layerInfo.hasOwnProperty('second') && layerInfo.second != null) {
                variantOb.name += '-' + layerInfo.second.name
                variantOb.id += '-' + layerInfo.second.uuid
                variantOb.type += '-crust'
                price += layerInfo.second.price
                variantOb.value.displayGross += layerInfo.second.price
              }
              variantOb.name = this.convertStringSnakeCase(variantOb.name)
              bundleItems.push({
                productId: _menu.product_uuid,
                category: _menu.category || '', // not yet from api
                quantity: '1',
                name: this.convertStringSnakeCase(_menu.name),
                purchaseMethod: 'half-half',
                variant: variantOb,
                value: {
                  displayGross: price,
                  displayTax: 0
                }
              })
            }
            item.product.bundleItems = bundleItems
          }
          cart.lines.push(item)
        }
      }
      if (includeDiscount) {
        cart.discount = {
          lines: [],
          value: {
            'displayGross': '0.00',
            'displayTax': '0.00'
          }
        }
        if (cartData.coupon) {
          cart.discount.value.displayGross = cartData.coupon.total_discount

          for (let c in cartData.coupon.data) {
            if (cartData.coupon.data[c].discount_type != vm.$const.COUPON_TYPE_ITEM) {
              cart.discount.lines.push({
                id: cartData.coupon.data[c].code,
                name: this.convertStringSnakeCase(cartData.coupon.data[c].name),
                code: cartData.coupon.data[c].code,
                type: 'fixed',
                size: cartData.coupon.data[c].discount_value,
                value: {
                  'displayGross': cartData.coupon.data[c].discount_value,
                  'displayTax': '0.00'
                }
              })
            }
          }
        }
      }
      return cart
    },
    getSlugCategoryCurrent(category) {
      let currentSlug = ''
      if (category) {
        currentSlug = category.name && category.name.en ? category.name.en.toLowerCase() : (category.name ? category.name.toLowerCase() : '')
        switch (currentSlug) {
          case 'pizza':
            currentSlug = 'pizzas'
            break;
          case 'promotion':
            currentSlug = 'deals'
            break;
          case 'promos':
            currentSlug = 'deals'
            break;
          case 'promo':
            currentSlug = 'deals'
            break;
          case 'cheesypasta':
            currentSlug = 'deals'
            break;
          case 'beverages':
            currentSlug = 'drinks'
            break;
          case 'beverage':
            currentSlug = 'drinks'
            break;
          default:
            currentSlug = currentSlug
            break;
        }
      }
      return currentSlug
    },
    /**
     * Load all default messages from GMS and parse error code to appropriate message
     * @param error - Object
     * @returns {string} parsed message
     */
    getMessageFromGms (error) {
      const messages = this.$session.get('messages') || []
      const errorCode = error.error.code
      const lang = this.$session.get('lang')

      const filteredMsg = messages && errorCode ? messages.find(element => element.error_code === errorCode) : undefined
      let message = filteredMsg && filteredMsg.hasOwnProperty('error_message') ? filteredMsg.error_message[lang] : error.error.message

      if (!main.$const.GMS_EXCEPTION_CODE.includes(errorCode)) {
        message = filteredMsg ? filteredMsg.error_message[lang] : message
      }

      return message
    },
    eventTrackingLoadCart(vm) {
      console.info('+++++++++++++eventTrackingLoadCart data ++++++++++++++')
      let layer = {
        'event': 'cart.load.auto.dataLayer.load',
        'cart': this.generateCartBasic(vm, true)
      }
      console.info('+++++++++++++eventTrackingLoadCart data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingLoadCart end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingFormLoad(form) {
      console.info('+++++++++++++eventTrackingFormLoad ++++++++++++++')
      let data = {
        'event': 'form.load.auto.dataLayer.load',
        'form': {
          'id': form.id,
          'name': form.name,
          'category': form.category,
          'target': form.url
        }
      }
      console.info('+++++++++++++eventTrackingFormLoad data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingFormLoad end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingFormSubmit(form) {
      console.info('+++++++++++++eventTrackingFormSubmit ++++++++++++++')
      let data = {
        'event': 'form.interact.manual.submit.formSubmit',
        'form': {
          'id': form.id
        }
      }
      console.info('+++++++++++++eventTrackingFormSubmit data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingFormSubmit end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingFormSuccess(form, method) {
      console.info('+++++++++++++eventTrackingFormSuccess ++++++++++++++')
      let data = {
        'event': 'form.load.auto.success.formSuccess',
        'form': {
          'id': form.id
        }
      }
      if (method) {
        data.method = method
      }
      console.info('+++++++++++++eventTrackingFormSuccess data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingFormSuccess end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingFormError(form) {
      console.info('+++++++++++++eventTrackingFormError ++++++++++++++')
      let data = {
        'event': 'form.load.auto.error.formError',
        'form': {
          'id': form.id
        },
        'error': {
          'code': form.error.code,
          'type': form.error.type,
          'error': form.error.error
        }
      }
      console.info('+++++++++++++eventTrackingFormError data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingFormError end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingShippingInfo(vm) {
      try {
        console.info('+++++++++++++eventTrackingShippingInfo ++++++++++++++')
        let shipping = 'delivery';
        const orderType = vm.$disposition.getByKey(vm, 'orderType', 'D')
        if (orderType === vm.$const.CARRYOUT) {
          shipping = 'carryout';
        }
        let data = {
          'event': 'cart.interact.auto.dataLayer.shippingInfo',
          'shipping_tier': shipping
        }
        console.info('+++++++++++++eventTrackingShippingInfo data ++++++++++++++')
        console.info(data)
        console.info('+++++++++++++eventTrackingShippingInfo end ++++++++++++++')
        dataLayer.push(data)
      } catch (error) {
        console.error(error);
        console.error('+++++++++++++eventTrackingShippingInfo error ++++++++++++++')
      }
    },
    eventTrackingPaymentMethodSelected(paymentMethod) {
      try {
        console.info('+++++++++++++eventTrackingPaymentMethodSelected ++++++++++++++')
        let data = {
          'event': 'cart.interact.manual.submit.paymentMethodSelected',
          'payment_type': paymentMethod
        }
        console.info('+++++++++++++eventTrackingPaymentMethodSelected data ++++++++++++++')
        console.info(data)
        console.info('+++++++++++++eventTrackingPaymentMethodSelected end ++++++++++++++')
        dataLayer.push(data)
      } catch (error) {
        console.error(error);
        console.error('+++++++++++++eventTrackingPaymentMethodSelected error ++++++++++++++')
      }
    },
    eventTrackingAutoLocalised() {
      try {
        console.info('+++++++++++++eventTrackingAutoLocalised ++++++++++++++')
        let data = {
          'event': 'user.interact.auto.success.auto.localisation'
        }
        console.info('+++++++++++++eventTrackingAutoLocalised data ++++++++++++++')
        console.info(data)
        console.info('+++++++++++++eventTrackingAutoLocalised end ++++++++++++++')
        dataLayer.push(data)
      } catch (error) {
        console.error(error);
        console.error('+++++++++++++eventTrackingAutoLocalised error ++++++++++++++')
      }
    },
    eventTrackingFailureLocalised() {
      try {
        console.info('+++++++++++++eventTrackingFailureLocalised ++++++++++++++')
        let data = {
          'event': 'user.interact.auto.failure.localisation'
        }
        console.info('+++++++++++++eventTrackingFailureLocalised data ++++++++++++++')
        console.info(data)
        console.info('+++++++++++++eventTrackingFailureLocalised end ++++++++++++++')
        dataLayer.push(data)
      } catch (error) {
        console.error(error);
        console.error('+++++++++++++eventTrackingFailureLocalised error ++++++++++++++')
      }
    },
    eventTrackingMoudle(data) {
      let links = []
      for (let i in data) {
        links.push(data[i])
      }
      let layer = {
        assets: {
          links: links
        }
      }
      console.info('+++++++++++++eventTrackingMoudle data ++++++++++++++')
      console.info(layer)
      console.info('+++++++++++++eventTrackingMoudle end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingModule(data) {
      console.info('+++++++++++++eventTrackingModule data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingModule end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingLoginSuccess (vm, method = 'email') {
      console.info('+++++++++++++eventTrackingLoginSuccess ++++++++++++++')
      let layer = {
        'event': 'user.interact.auto.success.loginSuccess',
        'method': method,
        'user': this.getUserDatalayer(vm)
      }
      console.info(layer)
      console.info('+++++++++++++eventTrackingLoginSuccess end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingLoginStart(method = 'email') {
      console.info('+++++++++++++eventTrackingLoginStart ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.click.loginStart',
        'method': method
      }
      console.info(layer)
      console.info('+++++++++++++eventTrackingLoginStart end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingLoginSubmit(method = 'email') {
      console.info('+++++++++++++eventTrackingLoginSubmit ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.submit.loginSubmit',
        'method': method
      }
      console.info(layer)
      console.info('+++++++++++++eventTrackingLoginSubmit end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingRegisterStart(method = 'email') {
      console.info('+++++++++++++eventTrackingRegisterStart ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.click.regStart',
        'method': method
      }
      console.info(layer)
      console.info('+++++++++++++eventTrackingRegisterStart end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingRegisterSubmit(method = 'email') {
      console.info('+++++++++++++eventTrackingRegisterSubmit ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.submit.regSubmit',
        'method': method
      }
      console.info(layer)
      console.info('+++++++++++++eventTrackingRegisterSubmit end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventTrackingModuleLoadDeal(vm, group) {
      console.info('+++++++++++++eventTrackingModuleLoadDeal++++++++++++++')
      let categoryUuid = vm.$session.get('categoryUuid') || vm.$store.getters.category_uuid
      let cateogry = {}
      let categories = vm.$session.get('listCategory')
      if (categories.length > 0) {
        for (let i in categories) {
          if (categories[i].uuid == categoryUuid) {
            cateogry = categories[i]
            break
          }
        }
        if (this.empty(cateogry)) {
          cateogry = categories[0]
        }
      }
      let items = []
      let products = []
      for (let i in group.items) {
        items.push({
          'id': group.items[i].uuid,
          'type': 'product',
          'position': (parseFloat(i) + 1)
        })
        let variants = []
        let item = group.items[i]
        if (item.first_layers && item.first_layers.length > 0) {
          for (let f in item.first_layers) {
            let price = item.first_layers[f].price
            if (typeof item.first_layers[f].second_layers !== 'undefined' && !vm.empty(item.first_layers[f].second_layers)) {
              for (let s in item.first_layers[f].second_layers) {
                price = item.first_layers[f].price + item.first_layers[f].second_layers[s].price
                variants.push({
                  id: item.first_layers[f].uuid + '-' + item.first_layers[f].second_layers[s].uuid,
                  name: this.convertStringSnakeCase(`${item.name} ${item.first_layers[f].name} ${item.first_layers[f].second_layers[s].name}`),
                  type: 'size-crust',
                  quantity: 1,
                  value: {
                    displayGross: price,
                    displayTax: 0
                  }
                })
              }
            } else {
              variants.push({
                id: item.first_layers[f].uuid,
                name: this.convertStringSnakeCase(`${item.name} ${item.first_layers[f].name}`),
                type: 'size',
                quantity: 1,
                value: {
                  displayGross: price,
                  displayTax: 0
                }
              })
            }
          }
        }
        products.push({
          'id': group.items[i].uuid,
          'name': this.convertStringSnakeCase(group.items[i].name),
          'category': cateogry.name || '',
          'variants': variants,
          'value': {
            displayGross: group.items[i].price || 0,
            displayTax: 0
          },
          'tax': {
            'type': '',
            'name': '',
            'size': ''
          },
          'purchaseMethod': 'deal',
          'bundleItems': []
        })
      }
      let data = {
        'event': 'module.load.manual.dataLayer.load',
        'modules': [
          {
            'id': group.uuid || '',
            'name': this.convertStringSnakeCase(group.name) || '',
            'type': 'merchandising',
            'placement': 'item-selection-box',
            'items': items
          }
        ],
        'products': products
      }
      console.info('+++++++++++++eventTrackingModuleLoadDeal data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingModuleLoadDeal end ++++++++++++++')
      dataLayer.push(data)
    },
    getProductByUUID(uuid, callback) {
      let vm = this
      let orderTime = this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''),
        this.$disposition.getByKey(this, 'collectionTimeValue', ''))
      if (!orderTime) {
        orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }
      let data = {
        tier: this.$disposition.getByKey(this, 'tier', '1'),
        order_type: this.$disposition.getByKey(this, 'orderType', 'D').charAt(0),
        order_time: orderTime,
        outlet_code: this.getOutletCode(this)
      }

      this.axios.getMenuDetails(uuid, data, function (response) {
        if (response.data.error) {
          vm.$notify({
            type: 'Error',
            title: vm.$t('invalid_item')
          })
          let slug = vm.$route.params.slug
          vm.redirectToMenuPage(slug)
        } else {
          callback(response.data.data.item, null);
          let uuidNameSeo = vm.$store.getters.uuidForNameSeoDuplicate || ''
          // use getter to know when param nameseo is sub or uuid
          let slug = vm.$route.params.slug || ''
          let sub = vm.$route.params.sub || ''
          let nameseo = vm.$route.params.nameseo || ''

          history.replaceState({}, '', `/order${slug ? '/' + slug : ''}${sub ? '/' + sub : ''}${uuidNameSeo ? '/' + uuidNameSeo : (nameseo || '')}`)
        }
      }, function (error) {
        callback(null, error)
      })
    },
    getProductByNameseo(nameSeo, callback) {
      let vm = this
      let uuidNameSeo = this.$store.getters.uuidForNameSeoDuplicate || ''
      let orderTime = this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''),
        this.$disposition.getByKey(this, 'collectionTimeValue', ''))
      if (!orderTime) {
        orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }
      let data = {
        friendly_seo_name: nameSeo,
        tier: this.$disposition.getByKey(this, 'tier', '1'),
        order_type: this.$disposition.getByKey(this, 'orderType', 'D').charAt(0),
        order_time: orderTime,
        outlet_code: this.getOutletCode(this)
      }
      this.axios.getComboDetailsFriendlyNameSeo(data, function (response) {
        if (response.data.error) {
          // duplicate friendly name seo
          let uuid = uuidNameSeo || nameSeo
          if (response.data.error.code === vm.$const.DUPLICATE_FRIENDLY_NAME_SEO && !uuidNameSeo) {
            vm.$notify({
              type: 'Error',
              title: vm.$t('invalid_item')
            })
            let slug = vm.$route.params.slug
            vm.redirectToMenuPage(slug)
          } else {
            vm.getProductByUUID(uuid, callback)
          }
        } else {
          callback(response.data.data.item, null);
        }
      }, function (error) {
        callback(null, error)
      })
    },
    redirectToMenuPage(slug = null, subSlug = null, nameseo = null, isReplace = false) {
      this.$root.$emit(this.$const.EVENT_BUS.REDIRECT_TO_MENU_PAGE, slug, subSlug, nameseo, isReplace);
    },
    redirectToPage(array){
      let categoryList = this.$session.get('listCategory')
      for (let i in categoryList) {
        if (this.lodash.includes(array, categoryList[i].slug)) {
          this.$router.push('/order/' + categoryList[i].slug)
          return
        }
      }
    },
    callEventBus(eventName, data, callback) {
      this.$bus.$emit(eventName, data, callback)
    },
    callEventListener(eventName, data, callback) {
      this.$root.$emit(eventName, data, callback);
    },
    back() {
      this.$router.back()
    },
    redirectToUrl(url, isRedirect = false, newTab = false, isReplace = false) {
      if (isRedirect) {
        if (newTab) {
          window.open(url, '_blank');
        } else {
          window.location.href = url;
        }
      } else {
        if(isReplace){
          this.$router.replace(url)
        }else{
          this.$router.push(url)
        }
      }

      return true
    },
    redirectTo(name, params) {
      this.$router.push({'name': name, 'params': params})
    },
    getCouponImage(item, image = null) {
      if (!image && (!item.image || this.lodash.isEmpty(item.image))) {
        let lang = this.$i18n ? this.$i18n.locale || this.$const.LANG_JP : this.$const.LANG_JP
        if (!this.empty(lang)) {
          lang = lang.toUpperCase()
        } else {
          lang = this.$const.LANG_JP.toUpperCase()
        }
        if (this.lodash.includes(this.$const.COUPON_TYPES.DISCOUNT, item.coupon_type_id)) {
          return this.$const.COUPON_IMAGES.DISCOUNT[lang];
        } else if (this.lodash.includes(this.$const.COUPON_TYPES.FREE_GIFT, item.coupon_type_id)) {
          return this.$const.COUPON_IMAGES.FREE_GIFT[lang];
        } else {
          return this.$const.COUPON_IMAGES.PROMOTION[lang];
        }
      } else {
        return image || item.image.desktop
      }
    },
    setActiveToppingList(extraToppingList, defaultToppingList) {
      //CHECK PER CATEGORY
      for (let ext in extraToppingList) {
        let count = 0;
        for (let def in defaultToppingList) {
          if (extraToppingList[ext].id == defaultToppingList[def].id) {
            count++;
          }

          extraToppingList[ext].isDisable = false
          if (count >= this.$const.TOPPING.MAX_PER_TOPPING) {
            extraToppingList[ext].isDisable = true
            break;
          }
        }
      }

      if (this.$const.TOPPING.MAX_TOPPING) {
        let defaultList = defaultToppingList.filter(topping => {
          return topping.type == this.$const.TOPPING.TYPE_EXTRA
        });

        if (defaultList && defaultList.length >= this.$const.TOPPING.MAX_TOPPING) {
          for (let ext in extraToppingList) {
            if (extraToppingList[ext].type == this.$const.TOPPING.TYPE_EXTRA) {
              extraToppingList[ext].isDisable = true
            }
          }
        }
      }
    },
    convertToKanaName(text, callback) {
      this.axios.apiCustomer.convertKana(text, (response) => {
        callback(null, response.data.data.result)
      }, function (error) {
        callback(true)
      })
    },
    convertSecond(datetime){
      if (!datetime) {
        datetime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }
      datetime = moment(datetime)
      datetime.set({second : 0})
      return datetime.format('YYYY-MM-DD HH:mm:ss')
    },
    getMenuRequest(categoryId = null, subCategoryId = null) {
      let orderTime = this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''),
        this.$disposition.getByKey(this, 'collectionTimeValue', ''))
      if (!orderTime) {
        orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }

      orderTime = this.convertSecond(orderTime)

      let data = {
        'order_time': orderTime,
        'tier': this.$disposition.getByKey(this, 'tier', '1'),
        'order_type': this.$disposition.init(this) ? this.$disposition.getByKey(this, 'orderType', 'D').charAt(0) : null
      }

      let outletCode = this.$disposition.getByKey(this, 'outletCode', null)
      if (outletCode) {
        data = {
          'order_time': orderTime,
          'outlet_code': this.$disposition.getByKey(this, 'outletCode', null),
          'tier': this.$disposition.getByKey(this, 'tier', '1'),
          'order_type': this.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
        }
      }

      if (categoryId) {
        data.category_id = categoryId
      }

      if (subCategoryId) {
        data.sub_category_id = subCategoryId
      }

      return data
    },
    getWaitingTime (vm) {
      let number = 'null'
      let type = vm.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
      let quoctime = vm.$disposition.getByKey(this, 'quoteTime', {})
      if (quoctime && quoctime.hasOwnProperty(type)) {
        number = quoctime[type]
      }
      return number
    },
    setOutletById(vm, outletId, orderType, callback) {
      main.callEventBus(main.$const.EVENT_BUS.LOADING, true)
      let data = {
        order_type: orderType.charAt(0),
        order_time: this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''),
          this.$disposition.getByKey(this, 'collectionTimeValue', '')),
        advance_order: this.$disposition.getByKey(this, 'advanceOrder', 0) || 0,
        outlet_id: outletId
      }

      this.axios.apiOutlet.checkOutletAvailable(data,
        function (response) {
          response = response.data
          if (response.status) {
            let data = vm.$disposition.get(vm)
            response = response.data.item
            // set data
            data.lat = response.lat
            data.long = response.long
            data.postalCode = response.zip
            //data.locationName = outletData.kanji_address
            //data.outletAddress = outletData.kanji_address
            data.orderType = orderType
            data.outletId = response.id
            data.outletName = response.name
            data.outletCode = response.code
            //data.addressCode = outletData.address_code
            data.advanceOrder = vm.$disposition.getByKey(vm, 'advanceOrder', 0) || 0
            data.tier = response.tier
            data.minCart = response.min_cart
            data.houseNo = ''
            data.landmark = ''
            data.quoteTime = response.quote_time
            vm.disposition = data

            let cart = vm.$cart.get(vm)

            if (cart.uuid) {
              vm.$modal.show('dialog', {
                text: vm.$t('confirm.remove_cart'),
                buttons: [
                  {
                    title: vm.$t('button_yes'),
                    handler: () => {
                      vm.proceessDispostion(vm, data, function () {
                        vm.$modal.hide('dialog')
                        vm.redirectToPage(vm.$const.SLUG_LIST.DEAL)
                      })
                    }
                  },
                  {
                    title: vm.$t('button_close')
                  }
                ]
              })
            } else {
              vm.proceessDispostion(vm, data, function () {
                vm.redirectToMenuPage()
              })
            }
          } else if (response.message && response.message != '') {
            vm.$notify({
              type: 'warn',
              title: response.message
            })
          }

          main.callEventBus(main.$const.EVENT_BUS.LOADING, false)
        },
        function (error) {
          error = error.error
          vm.eventTrackingLocalisationError({id: 'error-zip-code', error: 'invalid-zip-code'})
          main.callEventBus(main.$const.EVENT_BUS.LOADING, false)

          let message = vm.$t('modal.advance_order_message')
          if (error.code == vm.$const.LOCALIZATION_CODE.UNAVALIABLE) {
            message = vm.$t('message_find_outlet_empty')
            vm.$modal.show('dialog', {
              text: message,
              buttons: [
                {
                  title: vm.$t('button_close')
                }
              ]
            })
          } else if (error.code == vm.$const.LOCALIZATION_CODE.NOTOPEN) {
            message = vm.$t('localization.notopen')
            vm.$modal.show('dialog', {
              text: message,
              buttons: [
                {
                  title: vm.$t('button_close')
                }
              ]
            })
          } else if (error.code === vm.$const.LOCALIZATION_CODE.HUT19) {
            vm.callEventBus(vm.$const.EVENT_BUS.SHOW_MODAL_DELIVERY, true)
          } else if (error.code === vm.$const.LOCALIZATION_CODE.HUT20) {
            vm.callEventBus(vm.$const.EVENT_BUS.SHOW_MODAL_PICKUP, true)
          } else {
            vm.$modal.show(ASAPPopup, {outletId: outletId, orderType: orderType, hideASAP: 'true', message: message})

            // vm.callEventBus(vm.$const.EVENT_BUS.SHOW_ASAP, true)
            /*vm.$modal.show(ASAPPopup, {
              outletId: outletId,
              orderType: orderType,
              outletDataZip: outletData,
              hideASAP: 'true',
              message: message
            })*/
          }

        }
      )
    },
    getCurrentOrderType() {
      return this.$disposition.getByKey(this, 'orderType', '').toUpperCase()
    },
    proceessDispostion(vm, outlet, callback) {
      if(outlet.addressCode){
        let data = {address_code: outlet.addressCode}
        this.axios.apiOutlet.getAddressByAddressCode(data,
          function (response) {
            response = response.data.data.items
            if (response.length > 0) {
              outlet.prefectureName = response[0].level1
              outlet.cityName = response[0].level2
              outlet.villeageName = response[0].level3
              outlet.st = response[0].level4
            }

            vm.$disposition.set(vm, outlet)
            vm.$session.remove('cart')
            vm.$root.$emit('cartUpdate')

            callback()
          },
          function (error) {
          }
        )
      }else{
        vm.$disposition.set(vm, outlet)
        vm.$session.remove('cart')
        vm.$root.$emit('cartUpdate')

        callback()
      }
    },
    setHtmlClass(tagName, className, isRemove = false){
      const element = document.getElementsByTagName(tagName)[0];
      if(className){
        if(isRemove){
          element.className = body.className.replace(`/\b${className}\b/`, '');
        }else{
          element.classList.add(className);
        }
      }
    },
    setHtmlId(tagName, id){
      const element = document.getElementsByTagName(tagName)[0];
      element.id = id;
    },
    getTotalCartItem(cart) {
      let quantity = 0
      if (cart.data) {
        for (let i in cart.data) {
          quantity += cart.data[i].quantity
        }
      }
      return quantity
    },
    parseQueryString(data) {
      return Object.keys(data).map(function (key) {
        return key + '=' + data[key]
      }).join('&');
    },
    formatDate(date, formatInput, formatOutput){
      return moment(date, formatInput).format(formatOutput)
    },
    getByteLength(string, format = constants.FORMAT_CODE.UTF8){
      if(string){
        if(format == constants.FORMAT_CODE.JIS){
          return string.replace(/[^\x00-\x80｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝ ﾞ ﾟ]/g, 'xx').length;
        }else{
          return Buffer.byteLength(string, format);
        }
      }

      return null
    },
    takeCommonValue (array1, array2) {
      return array1.filter(value => array2.indexOf(value) !== -1)
    },
    setCacheLocalStorage(key, data, expireAmount = 5, expireUnit = 'minutes'){
      let now = moment()
      let dataStorage = {
        data: [],
        expired: null
      }
      if (data) {
        dataStorage.data = data
        dataStorage.expired = now
          .add(expireAmount, expireUnit)
          .format('YYYY-MM-DD HH:mm:ss')
        localStorage[key] = JSON.stringify(dataStorage)
      }
    },
    getCacheLocalStorage (key) {
      let now = moment()
      let data = null
      let isExpired = false
      if (localStorage[key]) {
        let cachedData = JSON.parse(localStorage[key])
        let expired = moment(cachedData.expired, 'YYYY-MM-DD HH:mm:ss')
        data = cachedData.data
        if (now.isAfter(expired)) {
          isExpired = true
          localStorage.removeItem(key)
        }
      } else {
        isExpired = true
      }
      return {
        expired: isExpired,
        data: data
      }
    },
    remoceCacheLocalStorage (key) {
      localStorage.removeItem(key)
    },
    separatePhone(phonenumber = '') {
      const oldPrefixPhone = ['+60']
      const prefixPhone = ['0']
      let prefix = 0

      if (!phonenumber)  return { prefix, phone: '' }

      prefix = phonenumber.substring(0, 3)
      if (oldPrefixPhone.includes(prefix)) {
        return { prefix, phone: phonenumber.substring(3)}
      }
      prefix = phonenumber.substring(0, 1)
      let _phonenumber = phonenumber
      if(prefixPhone.includes(prefix))
      {
        _phonenumber = phonenumber.substring(1)
      }
      return { prefix, phone: _phonenumber }
    },
    isDeviceMobile(){
      var isMobile = false;
      if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
        isMobile = true;
      }
      return isMobile
    },
    _getPhone (phone) {
      let _phone = phone
      if (_phone && _phone.length > 0) {
        _phone = _phone.replace('+', '')
        let prefix = _phone.substring(0, 2)
        if (prefix != '60') {
          if (_phone.charAt(0) != '0') {
            _phone = '60' + _phone
          } else {
            _phone = '6' + _phone
          }
        }
      }
      return _phone
    },
    smartechInit (vm) {
      try {
        smartech('create', vm.$const.SMARTECH.CREATE)
        smartech('register', vm.$const.SMARTECH.REGISTER)
        smartech('identify', '')
        smartech('dispatch', 1, {})
      } catch (error) {
        console.log('smartechPurchase error', error)
      }
    },
    smartechNewMember (user) {
      try {
        let phone = ''
        let datetime = moment()
        if (user) {
          phone = user.phone
          phone = this._getPhone(phone)
          // smartech('contact', '75', {
          //   'pk^mobile': `${phone}`,
          //   'email': `${user.email}`,
          //   'FIRST_NAME': `${user.first_name}`,
          //   'LAST_NAME': `${user.last_name}`,
          //   'GENDER': `${user.gender}`,
          //   'DATE_OF_BIRTH': `${user.birthday}`,
          // });
          // smartech('contact', '158', {
          //   'pk^mobile': `${phone}`,
          //   'email': `${user.email}`,
          //   'FIRST_NAME': `${user.first_name}`,
          //   'LAST_NAME': `${user.last_name}`,
          //   'GENDER': `${user.gender}`,
          //   'DATE_OF_BIRTH': `${user.birthday}`,
          //   'ENROLLED_PLATFORM': 'Web',
          //   'ENROLLED_ACCOUNT': 'PIZZA_HUT',
          //   'ENROLLED_DATE': `${datetime.format('YYYY-MM-DD HH:mm:ss')}`
          // });
          smartech('contact', '423',{
            'pk^mobile': `${phone}`,
            'email': `${user.email}`,
            'DATE_OF_BIRTH':`${user.birthday}`,
            'ENROLLED_PLATFORM': "web",
            'FIRST_NAME': `${user.first_name}`,
            'ENROLLED_ACCOUNT': 'PIZZA_HUT',
            'ENROLLED_DATE': `${datetime.format('YYYY-MM-DD HH:mm:ss')}`}),
          smartech('identify', `${phone}`);
          smartech('dispatch', 'New Registeration', {
            'email': `${user.email}`,
            'first_name': `${user.first_name}`,
            'date_of_birth': `${user.birthday}`,
            'enrolled_platform': 'Web',
            'enrolled_account': 'PIZZA_HUT',
            'enrolled_date': `${datetime.format('YYYY-MM-DD HH:mm:ss')}`
          });
        }
      } catch (error) {
        console.log('smartechPurchase error', error)
      }
    },
    smartechAddItem (vm, data, router) {
      try {
        let menu = data.item
        let image = ''
        if (data.item.hasOwnProperty('image') && typeof data.item !== 'undefined' && data.item.image) {
          image = data.item.image.desktop_detail || ''
        }
        let purl = router.history.current.fullPath
        let price =  (data.first ? data.first.price : 0 ) + (data.second ? data.second.price : 0) + data.price
        let item = {
          "purl": purl,
          "prid": menu.id,
          "name": menu.name,
          "brand": "PizzaHut",
          "variant": data.second ? data.second.name : '' ,
          "category": menu.category && menu.category.name && menu.category.name.hasOwnProperty(vm.$i18n.locale) ? menu.category.name[vm.$i18n.locale] : '',
          "price": price || 0,
          "prqt": data.quantity,
          "currency": vm.$const.CURRENCY_CODE,
          "item_id": menu.id,
          "item_name": menu.name,
          "item_price": price || 0,
          "item_category": menu.category && menu.category.name && menu.category.name.hasOwnProperty(vm.$i18n.locale) ? menu.category.name[vm.$i18n.locale] : '',
          "prodimg": image
        }
        console.log("=========smartech-add-to-cart==========")
        smartech('dispatch', 'Add To Cart' , item)
        // this.eventTrackingAddToCartV2(vm, menu)
      } catch (error) {
        console.log('smartechAddItem error', error)
      }
    },
    smartechViewCategory(vm, data, router) {
      try {
        let purl = router.history.current.fullPath
        let item = {
          "Category_Name": data.name,
          "prid": "",
          "Page_url":purl
        }
        console.log("=========smartech-category-view==========")
        smartech('dispatch', 'Product Browse',item)
      } catch (error) {
        console.log('smartechViewCategory error', error)
      }
      
    },
    smartechViewProduct(vm, data,firstLayer, secondLayer, router) {
      try {
        let price = (firstLayer.price || 0) + (secondLayer.price || 0)
        let purl = router.history.current.fullPath
        let image = ''
        if (data.hasOwnProperty('image') && data.image) {
          image = data.image.desktop_detail || ''
        }
        let item = {
          "purl": purl,
          "prid": data.id,
          "name": data.name,
          "brand": "PizzaHut",
          "variant": secondLayer.name || '',
          "category": data.category && data.category.name && data.category.name.hasOwnProperty(vm.$i18n.locale) ? data.category.name[vm.$i18n.locale] : '',
          "price": price,
          "prqt": 1,
          "currency": vm.$const.CURRENCY_CODE,
          "item_id": data.id,
          "item_name": data.name,
          "item_price": price,
          "item_category": data.category && data.category.name && data.category.name.hasOwnProperty(vm.$i18n.locale) ? data.category.name[vm.$i18n.locale] : '',
          "prodimg": image
        }
        console.log("=========smartech-product-view==========")
        smartech('dispatch', 'Product View' , item)
      } catch (error) {
        console.log('smartechViewProduct error', error)
      }
    },
    smartechCheckout (total = 0, number = 0) {
      try {
        let item = {
          "order_id" : "",
          "amount_paid" : total
        }
        console.log("=========smartech-checkout==========")
        smartech('dispatch', 'Checkout', item)
      } catch (error) {
        console.log('smartechCheckout error', error)
      }
    },
    smartechPurchase(vm,data){
      try {
        let order_items = []
        data.order_items.map(item => {
          let category = ""
          if(item.type === 0){
            category = item.items[0].base_category && item.items[0].base_category.name && item.items[0].base_category.name.hasOwnProperty(vm.$i18n.locale) ? item.items[0].base_category.name[vm.$i18n.locale] : ''
          }
          else{
            category = item.base_category && item.base_category.name && item.base_category.name.hasOwnProperty(vm.$i18n.locale) ? item.base_category.name[vm.$i18n.locale] : ''
          }
          let product = {
            "prid": item.uuid,
            "name": item.name,
            "price":item.total,
            "productimage" : "",
            "prqt" : item.quantity,
            "category" : category,
            "subcategory" : ""
          }
          order_items.push(product)
        })
        let item = {
          "orderid" : data.order_number,
          "amount" : data.total,
          "dateofurchase" : vm.convertUTCToTimeZone(vm.cart.collection_time, vm.cart.timezone).format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'),
          "items" : order_items
        }
        console.log('item_purchase',item)
        smartech('dispatch', 'Product Purchase', item);
      } catch (error) {
        console.log('smartechPurchase error', error)
      }
      
    },
    smartechRemoveItem(vm,data){
      try {
        if(data.length > 0){
          let menu = data[0]
          let second = {}
          if(!menu.combo_uuid || menu.combo_uuid === null){
            second = menu.items.length > 0 && menu.items[0].layer_info.second ? menu.items[0].layer_info.second : {}
          }
          let price = menu.total
          let item = {
            "purl": "",
            "prid": menu.id,
            "name": menu.name,
            "brand": "PizzaHut",
            "variant": second.name || '',
            "category": menu.base_category && menu.base_category.name && menu.base_category.name.hasOwnProperty(vm.$i18n.locale) ? menu.base_category.name[vm.$i18n.locale] : '',
            "price": price,
            "prqt": menu.quantity,
            "currency": vm.$const.CURRENCY_CODE,
            "item_id": menu.id,
            "item_name": menu.name,
            "item_price": price,
            "item_category": menu.base_category && menu.base_category.name && menu.base_category.name.hasOwnProperty(vm.$i18n.locale) ? menu.base_category.name[vm.$i18n.locale] : '',
          }
          smartech('dispatch', 'Remove from cart' ,item )
        }
      } catch (error) {
        console.log('smartechPurchase error', error)
      }
    }
    ,
    smartechConfirmation (cart) {
      return false
      /*smartech('dispatch', 3, {
        'f^order_id': cart.order_number,
        'i^amount_paid': cart.grant_total
      })
      if (!cart.user_id) {
        let phone = cart.phone;
        phone = this._getPhone(phone);
        smartech('contact', '75', {
          'pk^mobile': phone,
          'email': cart.email,
          'FIRST_NAME': cart.name,
          'LAST_NAME': ''
        })
      }*/
    },
    eventTrackingAddToCartV2 (vm, product) {
      let variant = ''
      if (product.first && !this.empty(product.first)) {
        variant = product.first.name
        if (product.second && !this.empty(product.second)) {
          variant += ' - ' + product.second.name
        }
      }
      dataLayer.push({
        'event': 'addToCart',
        'ecommerce': {
          'currencyCode': vm.$const.CURRENCY_CODE,
          'add': {
            'products': [{
              'name': product.name,
              'id': product.id,
              'price': product.price || 0,
              'brand': 'Pizza_Hut',
              'category': product.category && product.category.name && product.category.name.hasOwnProperty(vm.$i18n.locale) ? product.category.name[vm.$i18n.locale] : '',
              'variant': variant,
              'quantity': product.quantity
            }]
          }
        }
      })
    },
    eventTrackingCheckoutV2 (vm, dataCart = null, step = 0, option = '') {
      let prods = []
      for (let i in dataCart.data) {
        let item = dataCart.data[i]
        let variant = ''
        if (item.product_type === vm.$const.CARD_ITEM_TYPE.SINGLE) {
          let datamenu = vm.lodash.cloneDeep(item.items)
          for (let v in datamenu) {
            let layerInfo = vm.lodash.cloneDeep(datamenu[v].layer_info)
            if (typeof layerInfo.first !== 'undefined' && !vm.empty(layerInfo.first)) {
              variant = layerInfo.first.name
              if (typeof layerInfo.second !== 'undefined' && !vm.empty(layerInfo.second)) {
                variant += ' - ' + layerInfo.second.name
              }
            }
          }
        }
        prods.push({
          'id': item.id,
          'name': item.name,
          'price': item.total,
          'brand': 'Pizza_Hut',
          'category': item.base_category && item.base_category.name.hasOwnProperty(vm.$i18n.locale) ? item.base_category.name[vm.$i18n.locale] : '',
          'variant': variant,
          'quantity': item.quantity
        })
      }
      dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
          'checkout': {
            'actionField': {'step': step, 'option': option},
            'products': prods
          }
        },
        'eventCallback': function() {}
      })
    },
    eventTrackingCheckoutOption (step, checkoutOption) {
      dataLayer.push({
        'event': 'checkoutOption',
        'ecommerce': {
          'checkout_option': {
            'actionField': {'step': step, 'option': checkoutOption}
          }
        }
      })
    },
    eventTrackingRemoveFromCartV2 (vm, product) {
      let variantName = ''
      if (product.items.length > 0) {
        for (let i in product.items) {
          if (product.items[i].layer_info && product.items[0].layer_info.first) {
            variantName = product.items[0].layer_info.first.name
            if (product.items[0].layer_info.second) {
              variantName += ' - ' + product.items[0].layer_info.second.name
            }
          }
        }
      }
      dataLayer.push({
        'event': 'removeFromCart',
        'ecommerce': {
          'remove': {
            'products': [{
              'name': product.name,
              'id': product.item.id,
              'price': product.price,
              'brand': 'Pizza_Hut',
              'category': product.base_category && product.base_category.name.hasOwnProperty(vm.$i18n.locale) ? product.base_category.name[vm.$i18n.locale] : '',
              'variant': variantName,
              'quantity': product.quantity
            }]
          }
        }
      })
    },
    eventTrackingPurchases (vm, cart) {
      let coupons = []
      for (let coupon of cart.order_coupons) {
        coupons.push(coupon.coupon_code)
      }
      let order = {
        'id': cart.order_number,
        'revenue': cart.grant_total,
        'tax': cart.tax_total,
        'coupon': coupons.join(',')
      }

      let products = []
      for (let i in cart.order_items) {
        let menu = vm.lodash.cloneDeep(cart.order_items[i])
        let item = {
          'id': menu.uuid,
          'name': menu.name,
          'price': menu.total,
          'brand': 'Pizza_Hut',
          'category': menu.base_category && menu.base_category.name.hasOwnProperty(vm.$i18n.locale) ? menu.base_category.name[vm.$i18n.locale] : '',
          'variant': '',
          'quantity': menu.quantity
        }
        if (menu.type == vm.$const.CARD_ITEM_TYPE.SINGLE) {
          let variant = ''
          for (let v in menu.items) {
            if (typeof menu.items[v].first !== 'undefined' && !this.empty(menu.items[v].first) && menu.items[v].first.sku != '') {
              variant = menu.items[v].first.name
              if (typeof menu.items[v].first.second !== 'undefined' && !this.empty(menu.items[v].first.second) && menu.items[v].first.second.sku != '') {
                variant += '-' + menu.items[v].first.second.name
              }
              item.variant = variant
            }
          }
        }
        products.push(item)
      }

      dataLayer.push({
        'event': 'purchase',
        'ecommerce': {
          'purchase': {
            'actionField': {
              'id': order.id,
              'affiliation': 'Online Pizza hut',
              'revenue': order.revenue,
              'tax': order.tax,
              'shipping': '0',
              'coupon': order.coupon
            },
            'products': products
          }
        }
      });
    },
    eventTrackingProductClickV2 (vm, product) {
      dataLayer.push({
        'event': 'productClick',
        'ecommerce': {
          'click': {
            'actionField': {'list': 'Search Results'},
            'products': [{
              'name': product.name,
              'id': product.id,
              'price': product.min_price,
              'brand': 'Pizza_Hut',
              'category': product.category && product.category.name.hasOwnProperty(vm.$i18n.locale) ? product.category.name[vm.$i18n.locale] : '',
              'variant': product.variant || '',
              'position': ''
            }]
          }
        },
        'eventCallback': function() {
        }
      });
    },
    eventTrackingImpressions (vm, products) {
      let prods = []
      for (let i in products) {
        let menu = products[i]
        prods.push({
          name: menu.name,
          id: menu.id,
          price: menu.min_price || 0,
          brand: 'Pizza_Hut',
          category: menu.category && menu.category.name.hasOwnProperty(vm.$i18n.locale) ? menu.category.name[vm.$i18n.locale] : '',
          variant: '',
          position: (i * 1) + 1
        })
      }
      dataLayer.push({
        'ecommerce': {
          'currencyCode': vm.$const.CURRENCY_CODE,
          'impressions': products
        }
      })
    },
    getTextInErrorMessage (code) {
      let result = ''
      const messages = this.$session.get('messages')
      const lang = this.$session.get('lang')
      if (messages && messages.length > 0) {
        messages.forEach(item => {
          if (item.error_code === code && item.active === 1) {
            result = item.error_message ? item.error_message[lang] : ''
          }
        })
      }
      return result
    },
    evenTrackingNotInDeliveryZone(address,  lat = '', lng = ''){
      console.info("+++++++++++++++++evenTrackingNotInDeliveryZone+++++++++++++++")
      let data = {
        'event': 'deadEnd',
        'eventCategory': 'Dead End',
        'eventAction': 'Not in Delivery Zone',
        'eventLabel': 'Address: '+ address + '. latlong: ' + lat + ', ' + lng,
        'eventValue': 'undefined'
      }
      console.info('+++++++++++++evenTrackingNotInDeliveryZone data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++evenTrackingNotInDeliveryZone end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingDeliveryDeadZone(statusAvailable) {
      console.info("+++++++++++++++++eventTrackingDeliveryDeadZone+++++++++++++++")
      let collectionStatus = 'UnAvailable'
      if(statusAvailable == 'UnAvailable')
        collectionStatus = 'Available'
      let data = {
        'event': 'deadEnd',
        'eventCategory': 'Dead End',
        'eventAction': 'Delivery Deadzone',
        'eventLabel': 'Collection ' + collectionStatus,
        'eventValue': 'undefined'
      }
      console.info('+++++++++++++eventTrackingDeliveryDeadZone data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingDeliveryDeadZone end ++++++++++++++')
      dataLayer.push(data)
    },
    evenTrackingHutIsBouncing(hutID){
      console.info("+++++++++++++++++evenTrackingHutIsBouncing+++++++++++++++")
      let data = {
        'event': 'deadEnd',
        'eventCategory': 'Dead End',
        'eventAction': 'Hut is Bouncing',
        'eventLabel': 'Hut ID: '+ hutID,
        'eventValue': 'undefined'
      }
      console.info('+++++++++++++evenTrackingHutIsBouncing data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++evenTrackingHutIsBouncing end ++++++++++++++')
      dataLayer.push(data)
    },
    eventTrackingHutClosed(hutID) {
      console.info("+++++++++++++++++eventTrackingHutClosed+++++++++++++++")
      let data = {
        'event': 'deadEnd',
        'eventCategory': 'Dead End',
        'eventAction': 'Hut Closed',
        'eventLabel': 'Hut ID: ' + hutID,
        'eventValue': 'undefined'
      }
      console.info('+++++++++++++eventTrackingHutClosed data ++++++++++++++')
      console.info(data)
      console.info('+++++++++++++eventTrackingHutClosed end ++++++++++++++')
      dataLayer.push(data)
    },
    checkValue (value) {
      if (value === null || value === undefined || value === '' || value === 'null' || value === 'undefined') {
        return false
      }
      return true
    },
    getValueFromAttr (item, attr, defaultValue) {
      if (!this.checkValue(item) || !this.checkValue(attr)) {
        return defaultValue !== undefined ? defaultValue : null
      }
      if (attr.indexOf('.') > -1) {
        const arrs = attr.split('.')
        let result = item
        for (let i = 0; i < arrs.length; i++) {
          result = result[arrs[i]]
          if (!this.checkValue(result)) {
            return defaultValue !== undefined ? defaultValue : null
          }
        }
        return result
      }
      if (!this.checkValue(item[attr])) {
        return defaultValue !== undefined ? defaultValue : null
      }
      return item[attr]
    },
    getArrsInArrs (value, data, attr) {
      const vm = this
      if (!this.checkValue(data) || !this.checkValue(attr)) {
        return []
      }
      const arrs = data.filter(function (item) {
        return vm.getValueFromAttr(item, attr) === value
      })
      return arrs
    },
    isPizzaItem(item, isCombo = false) {
      if (isCombo) {
        return item.first_layers.length > 0
      } else {
        return this.lodash.has(item, 'first_layers') && !this.lodash.isNil(item.first_layers) && item.first_layers.length > 1
      }
    },
    initABTesting (vm,method) {
      const DEFAULT_CONFIG_AB_TESTING = {
        environment: 'browser',
        storage: 'localStorage',
        storagePrefix: 'test',
        onSetExperiment: (data) => {
          vm.sendEventGA(vm, data.experimentGoal, data.experimentName, data.experimentName + '_' + data.variantTitle, null, true)
        }
      }
      setupExperiments(method, DEFAULT_CONFIG_AB_TESTING)
    },
    sendEventGA (vm, category, action, label, value, nonInteraction) {
      const payload = {
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: value,
        nonInteraction: nonInteraction
      }
      console.log('payload', payload)
      vm.$ga.event(payload)
    },
    getValueExperiment (testingName,experiment) {
      for(let i of constants.AB_TESTING_FUNCTIONAL){
        if(i && i.name && i.name === testingName){
          for(let v of i.variants){
            if(v.title === experiment){ return v.value}
          }
        }
      }
    },
    setDataTimeSlot(vm,data,timezone) {
      let responseData = {}
      let openingDateTime = {}
      let defaultDate = vm.$disposition.getByKey(vm, 'collectionTime', '')
      let order_type = vm.orderType || this.$disposition.getByKey(vm, 'orderType', 'D').charAt(0)
      let now = moment().tz(timezone)
      let tomorrow = moment().tz(timezone).add(1, 'days')
      let startTimeOrg = {}
      let hourNextDate = []
      let arrOpeningData = []

      for (let _d in data) {
        let obTime = []

        let date = moment.utc(_d.date).tz(timezone)
        if (date.dayOfYear() >= now.dayOfYear()) {
          let info = data[_d].info
          for (let e of info.business_date) {
            if (e.start && e.end) {
              if(hourNextDate.length > 0) {
                obTime = _.cloneDeep(hourNextDate)
              }
              hourNextDate = []
              let info_interval = e.interval
              let info_quoteTime = e.quote_time
              let dateFormat = this.convertUTCToTimeZone(e.start, info.timezone).format('YYYY-MM-DD')
              let startTime = this.convertUTCToTimeZone(e.start, info.timezone)
                .add(info_quoteTime, 'minutes')
              let endTime = this.convertUTCToTimeZone(e.end, info.timezone)

              // startTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))
              // endTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))
              if (endTime.format('HH:mm:ss') == '00:00:00') {
                endTime.set('hour', 23)
                endTime.set('minute', 55)
                endTime.set('second', 59)
              }

              let startTimeOrg = _.cloneDeep(startTime)

              // if (order_type && order_type.toUpperCase() == vm.$const.CARRYOUT) {
              //   info.quote_time = vm.$const.QUOTE_TIME_CARRYOUT
              // }

              //TODAY
              let nextMinute = null
              if (now.format('YYYY-MM-DD') == date.format('YYYY-MM-DD')) {
                if (now.isAfter(startTime)) {
                  startTime = moment().tz(info.timezone).add(info_quoteTime, 'minutes')
                }
              }
              let intervalValue = vm.getIntervalTimeSlot(vm, info, startTime, order_type)
              if (intervalValue != null) {
                if (intervalValue == -1) {
                  intervalValue = info_interval
                }
              } else {
                intervalValue = info_interval
              }
              if (now.format('YYYY-MM-DD') == date.format('YYYY-MM-DD')) {
                nextMinute = (intervalValue * (Math.floor(startTime.get('minute') / intervalValue)))
                // eslint-disable-next-line no-unmodified-loop-condition
                while (nextMinute < startTime.get('minute') && intervalValue > 0) {
                  nextMinute += intervalValue
                }
                startTime.minute(nextMinute)
              }
              //subtract interval at start time
              startTime.subtract(intervalValue,'minutes')

              //Check start & end are same date
              let check_start = _.cloneDeep(startTime)
              let check_end = _.cloneDeep(endTime)
              let isSameDate = check_start.format('YYYY-MM-DD') == check_end.format('YYYY-MM-DD') ? true : false

              while (startTime.isBefore(endTime)) {
                let interval = vm.getIntervalTimeSlot(vm, info, startTime, order_type);
                let isAdd = true;

                if (interval != null) {
                  if (interval == -1) {
                    isAdd = false
                    interval = info_interval
                  }
                } else {
                  interval = info_interval
                }

                // expired time (eg: 23:45 - 00:00)
                let nextTime = this._.cloneDeep(startTime)
                nextTime.add(interval, 'minutes')
                if (nextTime < now) {
                  isAdd = false
                }
                startTime = startTime.add(interval, 'minutes')
                let currentFormat = startTime.format('HH:mm');
                // end expired time
                if (endTime.format('YYYY-MM-DD') > startTime.format('YYYY-MM-DD') && isAdd) {
                  obTime.push(currentFormat)
                } else if(isAdd) {
                  if(isSameDate)
                    obTime.push(currentFormat)
                  else
                    hourNextDate.push(currentFormat)
                }
              }
              if (!this.empty(obTime) && (obTime.length > 1 || obTime[0] != vm.$t('asap'))) {
                  let result = {}
                  result = vm.setDateTimeTimeSlot(vm,
                                                  dateFormat,
                                                  obTime,
                                                  now.format('YYYY-MM-DD'),
                                                  tomorrow.format('YYYY-MM-DD'),
                                                  startTimeOrg,
                                                  info.timezone)
                  openingDateTime = Object.assign(openingDateTime, result)
              }
            }
          }
        }
      }
      let flag = false
      responseData.openingDateTime = openingDateTime
      if (vm.$disposition.getByKey(vm, 'advanceOrder', '') == 1) {
        for (let date in openingDateTime) {
          if (date == defaultDate.pickedDay) {
            responseData.choiceDay = defaultDate.pickedDay
            responseData.hours = openingDateTime[date].data
            if (_.indexOf(openingDateTime[date].data, defaultDate.pickedHours) >= 0) {
              responseData.choiceHour = defaultDate.pickedHours
            } else {
              responseData.choiceHour = openingDateTime[date].data[0]
            }
            flag = true
            break
          }
        }
      }

      if (!flag) {
        for (let date in openingDateTime) {
          responseData.choiceDay = date
          responseData.hours = openingDateTime[date].data
          responseData.choiceHour = openingDateTime[date].data[0]
          flag = true
          break
        }
      }

      return responseData

      // this.setDefaultChosen(defaultDate)
      // this.callEventBus(this.$const.EVENT_BUS.LOADING, false)
    },
    setDateTimeTimeSlot(vm,obDate, obTime, today, tomorrow, startTimeOrigin,timezone) {
      let openingDateTime = {}
      let label = ''
      if(obDate == today){
        label = vm.$t('today')
      }else if(obDate == tomorrow){
        label = vm.$t('tomorrow')
      }else {
        label = moment(obDate).format('DD/MM/YYYY')
      }

      if (!openingDateTime[obDate]) {
        openingDateTime[obDate] = {'label': label, 'data': obTime}
      } else {
        let oldData = openingDateTime[obDate].data
        let newData = obTime
        openingDateTime[obDate].data = oldData.concat(newData)
      }
      if (openingDateTime[obDate].data.length <= 0) {
        delete openingDateTime[obDate]
      } else {
        let hide = false
        if (vm.hideASAP && this.hideASAP == 'true') {
          hide = true
        }
        if (obDate == today && !hide) {
          // check hide asap when asap time not available to order
          let time = moment.tz(timezone).format('YYYY-MM-DD HH:mm')
          let timestart = startTimeOrigin.format('YYYY-MM-DD HH:mm')
          if (time >= timestart && this.$disposition.getByKey(vm,'orderType','') == this.$const.CARRYOUT) {
            openingDateTime[obDate].data.unshift(vm.$t('asap'))
          }
        }
      }
      return openingDateTime
    },
    checkASAP (obj, date, isASAP) {
      const now = moment.tz(new Date(), obj.timezone)
      const today = moment.tz(new Date(), obj.timezone)
      const strNow = today.format('YYYY-MM-DD')
      if (moment(date).format('YYYY-MM-DD') !== strNow) {
        return obj.times
      }
      const result = []
      // TODO Add ASAP
      const start = moment(now.add(obj.quoteTime, 'minutes'))
      const startDate = moment.utc(obj.startDate).tz(obj.timezone)
      const endDate = moment.utc(obj.endDate).tz(obj.timezone)
      if (start.isAfter(endDate)) {
        return []
      }
      if (isASAP && start.isSameOrAfter(startDate) && start.isSameOrBefore(endDate)) {
        result.push({
          label: this.$t('asap'),
          value: 'ASAP'
        })
      }
      if (obj.times && obj.times.length > 0) {
        obj.times.forEach((item) => {
          if (start.format('HH:mm') <= item.value) {
            result.push(item)
          }
        })
      }
      return result
    },
    generateDateOrder (data) {
      const result = []
      if (data.length === 0) {
        return result
      }
      const timezone = this.getValueFromAttr(data, '0.info.timezone')
      const now = moment(moment.tz(new Date(), timezone))
      let today = moment(moment.tz(new Date(), timezone), 'YYYY-MM-DD')
      today = moment(today.format('YYYY-MM-DD'), 'YYYY-MM-DD')
      const tomorrow = moment(now, 'YYYY-MM-DD').add(1, 'days')
      try {
        data.forEach((item) => {
          let label = ''
          const date = moment(item.date, 'YYYY-MM-DD')
          const businessDate = this.getValueFromAttr(item, 'info.business_date')
          const end = moment.utc(businessDate[0].end).tz(timezone)
          if (date.isSameOrAfter(today) && end.isSameOrAfter(now)) {
            if (date.format('YYYY-MM-DD') === today.format('YYYY-MM-DD')) {
              label = this.$t('today')
            } else if (date.format('YYYY-MM-DD') === tomorrow.format('YYYY-MM-DD')) {
              label = this.$t('tomorrow')
            } else {
              label = moment(date).format('DD/MM/YYYY')
            }
            result.push({ label, value: date.format('YYYY-MM-DD') })
          }
        })
      } catch (error) {
        console.error(`Error function generateDateOrder: ${error}`)
      }
      return result
    },
    generateTimeOrder (data) {
      const result = {}
      if (data.length === 0) {
        return result
      }
      try {
        let timesTomorrow = []
        const orderType = (this.orderType && this.orderType.charAt(0)) || this.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
        data.forEach((item) => {
          const date = moment(item.date, 'YYYY-MM-DD')
          let times = []
          if (timesTomorrow.length > 0) {
            times = JSON.parse(JSON.stringify(timesTomorrow))
          }
          timesTomorrow = []
          const timezone = this.getValueFromAttr(item, 'info.timezone')
          const businessDate = this.getValueFromAttr(item, 'info.business_date')
          const advanceDuration = this.getValueFromAttr(item, 'info.advance_duration', [])
          const startDate = businessDate[0].start
          const endDate = businessDate[0].end
          const start = moment.utc(businessDate[0].start).tz(timezone)
          const end = moment.utc(businessDate[0].end).tz(timezone)
          const quoteTime = businessDate[0].quote_time
          let intervalTime = (advanceDuration && advanceDuration.length > 0) ? this.getValueFromAttr(advanceDuration, '0.duration.' + orderType) : businessDate[0].interval
          let current = start.add(quoteTime, 'minutes')
          let checkStopOrder = intervalTime === -1;
          if (checkStopOrder) {
            // Stop order
            intervalTime = businessDate[0].interval
            let advanceDate = moment.utc(advanceDuration[0].date).tz(timezone)
            let opening = moment.utc(advanceDuration[0].date + ' ' + advanceDuration[0].opening).tz(timezone)
            opening.year(advanceDate.get('year')).month(advanceDate.get('month')).date(advanceDate.get('date'))
            let closing = moment.utc(advanceDuration[0].date + ' ' + advanceDuration[0].closing).tz(timezone)
            closing.year(advanceDate.get('year')).month(advanceDate.get('month')).date(advanceDate.get('date'))
            while (current.isSameOrBefore(end)) {
              if (current.format('DD/MM/YYYY') === date.format('DD/MM/YYYY')) {
                if (current.isBefore(opening) || current.isAfter(closing)) {
                  times.push({
                    label: current.format('hh:mm A'),
                    value: current.format('HH:mm')
                  })
                }
              } else {
                timesTomorrow.push({
                  label: current.format('hh:mm A'),
                  value: current.format('HH:mm')
                })
              }
              current = start.add(intervalTime, 'minutes')
            }
          } else if (!checkStopOrder && advanceDuration && advanceDuration.length > 0) {
            // Duration order
            intervalTime = businessDate[0].interval
            let advanceDate = moment.utc(advanceDuration[0].date).tz(timezone)
            let opening = moment.utc(advanceDuration[0].date + ' ' + advanceDuration[0].opening).tz(timezone)
            opening.year(advanceDate.get('year')).month(advanceDate.get('month')).date(advanceDate.get('date'))
            let closing = moment.utc(advanceDuration[0].date + ' ' + advanceDuration[0].closing).tz(timezone)
            closing.year(advanceDate.get('year')).month(advanceDate.get('month')).date(advanceDate.get('date'))
            while (current.isSameOrBefore(end)) {
              if (current.isSameOrBefore(opening) || current.isSameOrAfter(closing)) {
                intervalTime = businessDate[0].interval
              } else {
                intervalTime = this.getValueFromAttr(advanceDuration, '0.duration.' + orderType)
              }
              if (current.format('DD/MM/YYYY') === date.format('DD/MM/YYYY')) {
                times.push({
                  label: current.format('hh:mm A'),
                  value: current.format('HH:mm')
                })
              } else {
                timesTomorrow.push({
                  label: current.format('hh:mm A'),
                  value: current.format('HH:mm')
                })
              }
              current = start.add(intervalTime, 'minutes')
            }
          } else {
            // Normal order
            while (current.isSameOrBefore(end)) {
              if (current.format('DD/MM/YYYY') === date.format('DD/MM/YYYY')) {
                times.push({
                  label: current.format('hh:mm A'),
                  value: current.format('HH:mm')
                })
              } else {
                timesTomorrow.push({
                  label: current.format('hh:mm A'),
                  value: current.format('HH:mm')
                })
              }
              current = start.add(intervalTime, 'minutes')
            }
          }
          result[date.format('YYYY-MM-DD')] = { times, timezone, quoteTime, intervalTime, startDate, endDate }
        })
      } catch (error) {
        console.error(`Error function generateTimeOrder: ${error}`)
      }
      return result
    },
    getStringIgnoreHTTMLTag (value) {
      return value.replace(/<(?:.|\n)*?>/gm, '');
    },
    getIntervalTimeSlot(vm,data, currentTime, order_type) {
      let interval = null;

      if (data.advance_duration && data.advance_duration.length) {
        for (let i in data.advance_duration) {
          let item = data.advance_duration[i];
          let date = moment.utc(item.date).tz(data.timezone)
          let closeTime = this.convertUTCToTimeZone(item.date + ' ' + item.closing, vm.timezone);
          let openTime = this.convertUTCToTimeZone(item.date + ' ' + item.opening, vm.timezone);
          closeTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))
          openTime.year(date.get('year')).month(date.get('month')).date(date.get('date'))

          if (closeTime.format('HH:mm:ss') == '00:00:00') {
            closeTime.set('hour', 23)
            closeTime.set('minute', 55)
            closeTime.set('second', 59)
          }
          if (currentTime.isSameOrAfter(openTime) && currentTime.isBefore(closeTime)) {
            if (order_type == vm.$const.DELIVERY.charAt(0)) {
              interval = item.duration.D
            } else {
              interval = item.duration.C
            }

            break;
          }
        }
      }

      return interval;
    },
    eventLocalisationStart () {
      console.info('+++++++++++++eventLocalisationStart ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.localisationStart'
      }
      console.info(layer)
      console.info('+++++++++++++eventLocalisationStart end ++++++++++++++')
      dataLayer.push(layer)
    },
    eventFindMyLocation () {
      console.info('+++++++++++++eventFindMyLocation ++++++++++++++')
      let layer = {
        'event': 'user.interact.manual.findMyLocation'
      }
      console.info(layer)
      console.info('+++++++++++++eventFindMyLocation end ++++++++++++++')
      dataLayer.push(layer)
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/index.js